/** biome-ignore-all lint/suspicious/noTemplateCurlyInString: expected */
import { getExecutingEnvironment } from "@app/resolveModule/env";

const locale = {
	"left-navigation": {
		expand: "Expand sidebar",
		collapse: "Collapse sidebar",
	},
	"floating-panel": {
		actions: "Panel actions",
		"dock-left": "Move to left panel",
		"dock-right": "Move to right panel",
		maximize: "Maximize to full screen",
		"reset-size": "Reset size",
		restore: "Restore",
		undock: "Detach to window",
	},
	"swagger-ui": {
		"api-definition-empty": "No API definition provided.",
		"api-definition-load-error": "Failed to load API definition.",
		"api-key": "API key",
		application: "Application",
		"apply-credentials": "Apply credentials",
		"apply-oauth2-credentials": "Apply OAuth2 credentials",
		"available-authorizations": "Available authorization methods",
		"available-values": "Available values",
		authorize: "Authorize",
		authorized: "Authorized",
		authorization: "Authorization",
		"authorization-header": "Authorization header",
		"authorization-method": "Authorization method",
		"authorization-url": "Authorization URL",
		"basic-authorization": "Basic authentication",
		callbacks: "Callbacks",
		cancel: "Cancel",
		clear: "Clear",
		"collapse-all": "Collapse all",
		"client-credentials-location": "Client credentials location",
		"client-id": "client_id",
		"client-secret": "client_secret",
		close: "Close",
		code: "Code",
		"default-value": "Default value",
		description: "Description",
		details: "Details",
		download: "Download",
		"download-file": "Download file",
		edit: "Edit",
		"edit-value": "Edit value",
		execute: "Execute",
		"expand-all": "Expand all",
		example: "Example",
		"example-description": "Example description",
		"example-value": "Example value",
		examples: "Examples",
		"controls-accept-header": "Controls the Accept header.",
		deprecated: "Deprecated",
		"deprecated-warning": "Warning: Deprecated operation",
		"remote-config-load-error": "Failed to load remote configuration.",
		"find-more-details": "More details in the documentation",
		flow: "Flow",
		headers: "Headers",
		hide: "Hide",
		"http-auth-unsupported-scheme": "uses an unsupported HTTP authentication scheme:",
		in: "In",
		"json-schema": {
			"additional-properties": "Additional properties",
			"all-of": "All conditions",
			"any-of": "At least one condition",
			"content-schema": "Content schema",
			contains: "Contains",
			"dependent-schemas": "Dependent schemas",
			else: "Else",
			if: "If",
			items: "Items",
			not: "Must not match",
			"one-of": "Exactly one condition",
			"prefix-items": "Prefix items",
			"property-names": "Property names",
			"required-when-defined": "Required when present",
			"then-keyword": "Then",
			"unevaluated-items": "Unevaluated items",
			"unevaluated-properties": "Unevaluated properties",
		},
		links: "Links",
		loading: "Loading",
		location: "Location",
		logout: "Logout",
		"media-type": "Media type",
		model: "Model",
		models: "Models",
		"modified-value": "Modified value",
		"mutual-tls-description":
			"This API or operation requires mutual TLS. Certificates are managed by your operating system or browser.",
		name: "Name",
		"no-example-available": "No example available",
		"no-links": "No links",
		"no-parameters": "No parameters",
		"oauth-scopes-apply": "This API requires the following scopes. Select the scopes to grant to Swagger UI.",
		"oauth-scopes-description":
			"Scopes are used to grant an application different levels of access to data on behalf of the end user. Each API may declare one or more scopes.",
		"oauth2-pkce-unavailable": "PKCE authorization is unavailable because browser crypto APIs are not available.",
		"oauth2-redirect-url-missing": "oauth2RedirectUrl is not configured. OAuth2 authorization cannot continue.",
		"openid-connect-url": "OpenID Connect URL",
		"operation-server-override": "These operation-level settings override the global server settings.",
		"parameter-content-type": "Parameter content type",
		"parameter-include-empty": "Send empty value",
		parameters: "Parameters",
		password: "Password",
		"path-server-override": "These path-level settings override the global server settings.",
		"request-body": "Request body",
		"request-content-type": "Request content type",
		"request-duration": "Request duration",
		"request-url": "Request URL",
		required: "required",
		reset: "Reset",
		"response-body": "Response body",
		"response-content-type": "Response content type",
		"response-headers": "Response headers",
		"remove-authorization": "Remove authorization",
		responses: "Responses",
		schema: "Schema",
		schemas: "Schemas",
		schemes: "Protocol",
		scopes: "Scopes",
		"server-response": "Server response",
		servers: "Servers",
		show: "Show",
		"try-it-out": "Try it out",
		token: "Token",
		"token-url": "Token URL",
		type: "Type",
		undocumented: "Undocumented",
		username: "Username",
		validation: {
			"array-max-items": "Array must contain no more than",
			"array-min-items": "Array must contain at least",
			"character-few": "characters",
			"character-many": "characters",
			"character-one": "character",
			"item-few": "items",
			"item-many": "items",
			"item-one": "item",
			"no-duplicates": "Duplicate values are not allowed",
			parameter: "Parameter",
			path: "path",
			"required-field": "Required value is missing",
			"required-property": "Required property is missing",
			"valid-json": "Value must be valid JSON",
			"value-boolean": "Value must be a boolean",
			"value-date-time": "Value must be a valid date and time",
			"value-file": "Value must be a file",
			"value-greater-or-equal": "Value must be greater than or equal to",
			"value-guid": "Value must be a valid GUID",
			"value-integer": "Value must be an integer",
			"value-less-or-equal": "Value must be less than or equal to",
			"value-max-length": "Value must be no longer than",
			"value-min-length": "Value must be at least",
			"value-number": "Value must be a number",
			"value-pattern": "Value must match the pattern",
			"value-string": "Value must be a string",
		},
		"validation-errors-retry": "Please correct the validation errors and try again.",
		value: "Value",
		webhooks: "Webhooks",
		"with-pkce": "with PKCE",
	},
	forms: {
		"catalog-edit-props": {
			name: "Catalog Settings",
			description: "Set the catalog parameters and its display",
			tabs: {
				title: "Sections",
				general: "General",
				icons: "Icon Library",
				storage: "Repository",
				language: "Languages and Versions",
				advanced: "Advanced",
				extended: "Format",
				lfs: "Git LFS",
				storageUsage: "Storage Usage",
			},
			sidebar: {
				git: "Git",
			},
			props: {
				title: {
					name: "Catalog Title",
					placeholder: "Enter the catalog name",
					description: "Displayed in the list of catalogs, on the card and in the editor interface.",
				},
				url: {
					name: "Name",
					placeholder: "Enter the repository name",
					description: "System name of the Git repository. Set when creating the catalog.",
				},
				docroot: {
					name: "Subdirectory",
					placeholder: "Specify the directory",
					description:
						"Path to the directory where all documentation will be stored in the repository. Defaults to the repository root. All articles (with all resources) will be moved to a new folder when saving.",
				},
				versions: {
					name: "Versions",
					placeholder: "Specify the versions",
					description:
						"List of versions (branches or tags). Specified as glob patterns, e.g., v19.* or release-*",
				},
				lfs: {
					lazy: {
						name: "Automatically download LFS files",
						description:
							"Download all LFS files when syncing the catalog instead of when opening an article.",
					},
					patterns: {
						name: "Tracked LFS files",
						placeholder: "Enter path patterns",
						description: "Path patterns for Git LFS to track (e.g., *.jpg, *.png, *.zip).",

						"default-tooltip": "Set commonly used file path patterns",
					},
					auto: {
						name: "Store new attachments in LFS",
						description: "Images, videos and files you add to articles will be stored in Git LFS",
					},
					exclude: {
						name: "Exceptions",
						placeholder: "Enter path patterns",
						description:
							"Files matching these patterns stay out of LFS (e.g., *.psd, *.ai). Applies to new attachments only.",
					},
				},
				filterProperty: {
					name: "Filter Property",
					placeholder: "Select a property",
					description: "Select a flag or enum property to use for filtering the catalog",
					none: "No filter",
				},
				language: {
					name: "Main language",
					placeholder: "English",
					description: "Main language of the catalog. Cannot be changed after selection",
				},
				description: {
					name: "Description",
					placeholder: "Enter a description",
					description:
						"Shown on the card of the catalog on the main page and can be used in the catalog search.",
				},
				style: {
					name: "Style",
					placeholder: "Blue",
					description: "Color style of the card catalog.",
				},
				code: {
					name: "Short Name",
					placeholder: "Enter a short name",
				},
				properties: {
					name: "Properties",
				},
				icons: {
					name: "Icons",
					description: "All uploaded icons will be available for insertion into the article.",
					fileConditions: "SVG format ∙ No larger than 500KB",
				},
				preview: {
					name: "Card Preview",
				},
			},
			section: {
				display: "Display on the homepage",
			},
			extended: {
				name: "Format",
			},
		},
		"catalog-extended-edit-props": {
			name: "Text Storage Format",
			props: {
				syntax: {
					name: "Article Markup Language",
					description:
						"By default, articles are saved in extended Markdown syntax. You can choose a different format: after saving the settings, all articles will be reformatted. You will only need to publish the changes",
					placeholder: "Legacy",
				},
			},
		},
		"catalog-create-props": {
			name: "New property",
			name2: "Edit property",
			description: "Set the property parameters and its display",
			description2: "Change the property parameters and its display",
			props: {
				name: {
					name: "Name",
					placeholder: "Enter a name",
				},
				type: {
					name: "Type",
					placeholder: "Select a type",
				},
				icon: {
					name: "Icon",
					placeholder: "Select an icon",
					description: "Icon that will be displayed in the property",
				},
				style: {
					name: "Style",
					placeholder: "Select a style",
					description: "Style with which the property will be displayed",
				},
				values: {
					name: "Values",
					placeholder: "Enter values",
					description: "Values that can be assigned to articles",
				},
			},
		},
		"article-edit-props": {
			name: "Properties",
			props: {
				title: {
					name: "Title",
					placeholder: "Enter the title",
					description: "The title of the article in the editor, navigation and published portal",
				},
				description: {
					name: "Description",
					placeholder: "Enter the description",
					description: "Used in SEO meta tag `description` when publishing.",
				},
				url: {
					name: "Article-url",
					placeholder: "Enter the URL",
					description:
						"Custom part of the link to your article. Allowed Latin letters, numbers and symbols -, _.",
				},
				searchPhrases: {
					name: "Search Phrases",
					placeholder: "Example: оформление отпуска",
					description:
						"List of phrases that will be used for searching the article. Used in search and snippet.",
				},
				aliases: {
					name: "Additional Article Paths",
					placeholder: "e.g. guide/install",
					description:
						"Specify paths from the catalog root where the article will also be available. Readers opening them will automatically land on this article.",
					"clear-auto": "Clear automatically added paths",
					"auto-tooltip": "Added automatically when moving or renaming the article or category",
				},
			},
		},
		"git-source-data": {
			props: {
				sourceType: {
					name: "Type",
				},
				url: {
					name: "Git Server URL",
					placeholder: "https://git-server.com",
					description: "Copy the URL from the main page of your repository",
				},
				token: {
					name: "Token",
					placeholder: "glpat-***************-***",
					description: "Token used for authorization on the git server",
				},
				password: {
					name: "Password",
					placeholder: "password",
					description: "Password used for authorization on the git server",
				},
				createDate: {
					name: "Creation Time",
					placeholder: "1707213960",
					description: "Time the token was obtained",
				},
				useToken: {
					name: "Use Token",
					description: "Use token instead of password",
				},
				usePassword: {
					name: "Use Password",
					description: "Use password instead of token",
				},
				refreshToken: {
					name: "Refresh Token",
					placeholder: "4740fbc6db719d42c158b88580be7633c1e386827ebe9134e9a5198c52cb2e4c",
					description: "Token for refreshing the main token",
				},
				userName: {
					name: "Author Name",
					description: "Will be displayed in the change history",
					placeholder: "John Doe",
				},
				gitServerUsername: {
					name: "Git Username",
					description: "Username used for authorization on the git server",
					placeholder: "john.doe",
				},
				userEmail: {
					name: "Email",
					description: "Will be displayed in the change history",
					placeholder: "john.doe@gmail.com",
				},
			},
		},
		"gitlab-source-data": {
			props: {
				sourceType: {
					name: "Type",
				},
				token: {
					name: "GitLab Token",
					placeholder: "glpat-***************-***",
					description: "Token used for authorization on the GitLab server",
				},
				url: {
					name: "GitLab Server URL",
					placeholder: "https://gitlab.com",
					description: "Log in to GitLab and copy the URL from the main page",
				},
				createDate: {
					name: "Creation Time",
					placeholder: "1707213960",
					description: "Token retrieval time",
				},
				refreshToken: {
					name: "Refresh Token",
					placeholder: "4740fbc6db719d42c158b88580be7633c1e386827ebe9134e9a5198c52cb2e4c",
					description: "Token for refreshing the main token",
				},
				userName: {
					name: "Author Name",
					description: "Will be displayed in the change history",
					placeholder: "John Doe",
				},
				userEmail: {
					name: "Email",
					description: "Will be displayed in the change history",
					placeholder: "john.doe@mail.com",
				},
			},
		},
		"gitea-source-data": {
			props: {
				sourceType: {
					name: "Type",
				},
				token: {
					name: "Gitea Token",
					placeholder: "31fa8d7b332125ed2d89b9b3d735e1292b499d82", // # gitleaks:allow
					description: "Token used for authorization on the Gitea server",
				},
				url: {
					name: "Gitea Server URL",
					placeholder: "https://gitea.com",
					description: "Log in to Gitea and copy the URL from the main page",
				},
				createDate: {
					name: "Creation Time",
					placeholder: "1707213960",
					description: "Token retrieval time",
				},
				refreshToken: {
					name: "Refresh Token",
					placeholder: "4740fbc6db719d42c158b88580be7633c1e386827ebe9134e9a5198c52cb2e4c",
					description: "Token for refreshing the main token",
				},
				userName: {
					name: "Author Name",
					description: "Will be displayed in the change history",
					placeholder: "John Doe",
				},
				userEmail: {
					name: "Email",
					description: "Will be displayed in the change history",
					placeholder: "john.doe@mail.com",
				},
			},
		},
		"gitverse-source-data": {
			props: {
				sourceType: {
					name: "Type",
				},
				token: {
					name: "Token",
					placeholder: "e5a43119d84f620fedfc0929e125ed4b10a6a5f4", // # gitleaks:allow
					description: "Token for authentication at GitVerse",
				},
				url: {
					name: "Server URL",
					placeholder: "https://gitverse.ru",
					description: "Log in to GitVerse and copy the URL from the main page",
				},
				createDate: {
					name: "Creation Time",
					placeholder: "1707213960",
					description: "Token retrieval time",
				},
				refreshToken: {
					name: "Refresh Token",
					placeholder: "4740fbc6db719d42c158b88580be7633c1e386827ebe9134e9a5198c52cb2e4c",
					description: "Token for refreshing the main token",
				},
				userName: {
					name: "Author Name",
					description: "Will be displayed in the change history",
					placeholder: "John Doe",
				},
				userEmail: {
					name: "Email",
					description: "Will be displayed in the change history",
					placeholder: "john.doe@mail.com",
				},
			},
		},
		"confluence-server-source-data": {
			props: {
				sourceType: {
					name: "Type",
				},
				domain: {
					name: "Confluence server URL",
					placeholder: "https://confluence.domain.com",
					description: "Copy the URL of your Confluence server",
				},
				password: {
					name: "Password",
					placeholder: "opxsdk_tvdg",
					description: "Enter the Confluence account password",
				},
				userName: {
					name: "Username",
					placeholder: "John",
					description: "Enter the Confluence account username",
				},
				token: {
					name: "Token",
					description: "Enter the Confluence account token",
					placeholder: "NzIzNTYyNTQ3NjQxOva29fNcHrLYMGH77/YuEAKpqy+Q",
				},
			},
		},
		"admin-login-props": {
			name: "Account Login",
			props: {
				login: {
					name: "Login",
					placeholder: "Enter login",
				},
				password: {
					name: "Password",
					placeholder: "Enter password",
				},
			},
			validationErrors: {
				wrongLoginOrPassword: "Wrong login or password",
			},
		},
		"fragment-editor": {
			name: "Fragment editor",
			props: {
				title: {
					name: "Title",
					placeholder: "My fragment",
				},
				id: {
					name: "Id",
					placeholder: "my_id",
				},
				content: {
					name: "Content",
				},
			},
		},
		"sign-in-enterprise": {
			name: "Sign in to Your Business Account",
			props: {
				email: {
					name: "Sign in to your Gramax Enterprise Server account",
					description: "Use your work email to connect to your organization's space.",
					placeholder: "Enter your email",
				},
			},
		},
		"clone-repo": {
			name: "Clone Git Repository",
			description: "Select a storage or add a new one",
			"enterprise-description": "Select a repository",
			props: {
				storage: {
					name: "Storage",
					placeholder: "Select a storage",
				},
				repository: {
					name: "Repository",
				},
				lfs: {
					lazy: {
						name: "Auto download LFS files",
						description:
							"Download all LFS files when syncing the catalog instead of downloading them when opening an article",
					},
				},
			},
			errors: {
				sourceKey: "Source is required",
				repository: "Repository is required",
				user: "User is required",
				connect: "Failed to connect to the storage. Please contact your administrator",
			},
		},
		"add-storage": {
			name: "Add new storage",
			name2: "Connect storage",
			name3: "Edit storage",
			description: "Specify the storage type and enter the necessary data",
			props: {
				storage: {
					name: "Storage",
					placeholder: "Select a storage",
				},
			},
		},
		"create-source": {
			name: "Add new source",
			description: "Specify the source type and enter the necessary data",
			props: {
				source: {
					name: "Source type",
					placeholder: "Select a source type",
					description: "Some options are available only in the desktop app",
				},
			},
		},
		"sign-in-ges-tauri": {
			props: {
				gesUrl: {
					name: "Gramax Enterprise Server URL",
					placeholder: "https://enterprise.gram.ax",
					description: "Specify the address of your Gramax Enterprise Server",
				},
			},
			errors: {
				urlIsNotValid: "URL is not valid",
				enterpriseServerIsNotAvailable: "Enterprise server is not available at this URL",
			},
		},
	},
	app: {
		update: {
			error: "Unable to update the application",
			retry: "Try again",
			available: "New version is available",
			updating: "Updating...",
			installed: "Update installed",
			more: "Detailed error",
			dmg: {
				title: "App is not installed",
				desc: `Move app to the «Applications» directory and run from there`,
			},
			code: {
				install: "Failed to install update",
				check: "Failed to check for updates",
				"not-found": "Server did not return update information",
				"download-failed": "Failed to download update",
				signature: "Failed to verify update",
				"check-enterprise-version": "Failed to check enterprise server version",
				reqwest: "Failed to fetch update from the server",
				"run-from-dmg": "Application launched from .dmg",
			},
		},
		loading: "loading",
		error: {
			offline: {
				"no-internet": "No internet connection",
				mode: "Offline mode",
			},
			"browser-not-supported": {
				title: "This browser is not supported",
				desc: "<span>Open Gramax in a <a href='https://gram.ax/resources/docs/app/web-editor'>different browser</a> or </span><a href='https://gram.ax'> download the app</a><span> to your computer</span>",
			},
			"wasm-init-timeout": {
				title: "Failed to initialize Gramax",
				desc: "The wasm module initialization is timed out. Please try again",
			},
			"unknown-error": "Unknown error",
			"cannot-load": "Unable to load the application",
			"not-https":
				"Missing <a href='https://developer.mozilla.org/en-US/docs/Web/API/Window/crossOriginIsolated'>cross-origin isolation</a> or HTTPS connection which is required to run application",
			"command-failed": {
				title: "Something went wrong",
				body: `<p>Reload the page and try again.</p><p>We will receive a problem report and try to fix it quickly. If the error blocks your work — create an issue in <a style="color: hsl(201 96% 32%)" href="https://github.com/Gram-ax/gramax/issues" target='${
					getExecutingEnvironment() === "tauri" ? "" : "target='_blank'"
				}'>GitHub</a>.</p>`,
			},
			"something-went-wrong": "Something went wrong",
		},
		"continue-in-browser": {
			title: "Opened in Gramax application",
			description:
				"The catalog is already open in the Gramax desktop application. Do you want to continue in the browser?",
			action: "Continue in browser",
		},
	},
	language: {
		name: "Language",
		ru: "Русский",
		en: "English",
		zh: "中文",
		hi: "हिन्दी",
		es: "Español",
		fr: "Français",
		ar: "العربية",
		pt: "Português",
		de: "Deutsch",
		ja: "日本語",
		ko: "한국어",
		it: "Italiano",
		tr: "Türkçe",
		nl: "Nederlands",
		pl: "Polski",
		sv: "Svenska",
		cs: "Čeština",
		ky: "Кыргызча",
		uz: "Узбекча",
		kk: "Қазақша",
		fa: "فارسی",
	},
	"style-guide": {
		"check-with-style-guide": "Check with style guide",
		"set-up-connection-and-style-guide": "Set up connection and style guide",
		"check-article": "Check current article",
		"set-up-style-guide": "Set up style guide settings",
		"set-up-connection": "Set up connection",
		"style-guide-settings": "Style guide settings",
		"delete-text": "Suggested to delete a fragment",
		"replace-text": "Suggestion for replacement",
		"LLM-provider": "LLM Provider",
		"enter-token": "Enter token",
		"verifying-token": "Verifying token",
		"invalid-token": "Invalid token",
		recommended: "Recommended",
		"settings-file": "Settings file",
		"invalid-file-format": "Invalid file format",
		"select-file": "Select a file",
		"no-file-selected": "No file selected",
		disabled: "Style guide is disabled",
		"failed-to-check": "Failed to check style article",
		"token-descriprion":
			"Your token remains on your device and is not transmitted to our servers. Please keep your token secure and do not share it with others.",
		"settings-description": `<p>To upload a style guide configuration file, follow these steps:</p>
<ol>
	<li>
		<p>
			Go to
			<a
				target="_blank"
				href="https://check.gram.ax"
				rel="noreferrer"
			>
				check.gram.ax
			</a>
			and navigate to "Settings".
		</p>
	</li>
	<li>
		<p>
			Set up the connection tokens for your chosen LLM provider (e.g., OpenAI, Anthropic, etc.).
		</p>
	</li>
	<li>
		<p>Create rules and test their functionality.</p>
	</li>
	<li>
		<p>Export the configuration file.</p>
	</li>
	<li>
		<p>Upload the resulting file in this form.</p>
	</li>
</ol>
<p>
	For more details, refer to the
	<a
		target="_blank"
		rel="noreferrer"
		href="https://gram.ax/resources/docs/review/comments"
	>
		documentation
	</a>
	.
</p>`,
	},
	workspace: {
		name: "Space",
		"configure-your-workspace": "Configure your space settings",
		"default-name": "Default Space",
		"enter-name": "Enter a name",
		"path-desc": "Directory on the local disk where working catalogs are located",
		selected: "Working directory: ",
		add: "Add space",
		edit: "Space settings",
		delete: {
			desktop: "Delete space? Working directory will remain on your computer",
			web: "Delete space? All catalogs in it will also be deleted",
		},
		"edit-style": "Edit style",
		"editing-css": "Editing CSS-styles",
		"css-configuration-instruction":
			"Use the {{instruction}} to configure the CSS styles of the application and the portal",
		instruction: "instruction",
		"css-style": "CSS-style",
		plugin: "Add plugin",
		logo: "Logo",
		appearance: "Appearance",
		"appearance-unavailable": "Appearance settings become available once the workspace has a working directory",
		"set-ai-server": "AI server",
		"set-ai-server-description": "Fill to enable AI functions in the space.",
		"ai-server-url": "AI server URL",
		"ai-server-url-description": "Enter the URL of your AI server",
		"ai-server-token": "AI server token",
		"ai-server-token-description": "Enter the token for your AI server",
		"ai-server-error": "Error connecting to AI server. Check the URL",
		"ai-token-set-error": "Token is not set. To connect, you need to set the token",
		"ai-token-error": "Token is invalid. Check it in the server settings",
		"delete-ai-server": "Delete AI server?",
		"lfs-section-title": "Git LFS",
		"lfs-section-description": "File patterns tracked by Git LFS. Applied to all catalogs in this workspace",
		"upload-error-title": "Upload Error",
		"invalid-logo-format-body": "Unsupported file format. Please upload a logo in SVG or PNG format only",
		"icon-invalid-files-body":
			"Errors occurred while uploading files [{{iconNames}}]. Please upload icons in SVG format and no larger than 500 KB",
		"icons-available-in-article": "Icons available in the article",
		"icons-uploaded": "Icons uploaded",
		"logo-upload-failed": "Failed to upload the logo",
		"logo-size-exceeded": "The logo size must not exceed 500KB",
		"css-styles-description": "Advanced styles settings for your space",
		"dark-logo-description": "Logo for dark theme. Used only in dark theme",
		"for-dark-theme": "For the dark theme",
		"default-logo-description":
			"Default logo. Used in the light theme and also in the dark theme if there is no separate dark theme logo",
		tooltip: {
			"only-current": {
				one: "catalog is available for sync in the current space",
				few: "catalogs are available for sync in the current space",
				many: "catalogs are available for sync in the current space",
			},
			"including-current": {
				one: "catalog is available for sync ({{current-count}} in current)",
				few: "catalogs are available for sync in {{workspace-count}} spaces ({{current-count}} in current)",
				many: "catalogs are available for sync in {{workspace-count}} spaces ({{current-count}} in current)",
			},
			"excluding-current": {
				one: "catalog is available for sync",
				few: "catalogs are available for sync in {{workspace-count}} spaces",
				many: "catalogs are available for sync in {{workspace-count}} spaces",
			},
			"only-one-excluding-current": {
				one: "catalog is available for sync in one of the spaces",
				few: "catalogs are available for sync in one of the spaces",
				many: "catalogs are available for sync in one of the spaces",
			},
			"has-changes": {
				one: "{{count}} catalog is available for sync",
				few: "{{count}} catalogs are available for sync",
				many: "{{count}} catalogs are available for sync",
			},
		},
		main: {
			title: "Home page view",
			view: {
				folder: "Folders",
				section: "Sections and folders",
			},
		},
	},
	"file-input": {
		"select-file": "Select a file",
		"no-file-chosen": "no file chosen",
		"logo-light": "Logo for light theme",
		"logo-dark": "Logo for dark theme",
		"dark-theme-only": "Displayed only in dark theme",
		"both-themes-if-no-dark": "Displayed in both themes if no dark logo",
		"use-dark-logo": "Another logo for dark theme",
		placeholder: "Icon / Emoji / Custom logo",
	},
	modal: {
		confirm: {
			"warning-have-changes": "Are you sure you want to exit editing mode? Your changes will be discarded",
		},
	},
	multilang: {
		name: "Multilingual",
		description: "Catalog articles in several languages with switching between them.",
		switch: "Switch language",
		"preview-article": "Preview article",
		warning: {
			action: {
				title: "Changes will apply to all languages",
				body: "You're about to update the structure of a multi-language catalog. To keep everything working smoothly, the structure needs to stay the same across all languages.",
			},
			delete: {
				title: "Delete content in all languages?",
				body: "You're about to delete content that exists in multiple languages. Since the catalog structure must stay the same across all languages, this will remove the same content in all other languages too.",
			},
		},
		"delete-confirm": "Are you sure you want to delete language?",
		"add-localization": "Add language",
		current: "You're already viewing this language",
		error: {
			"cannot-switch-to-self": "You can't delete or switch to the language you're currently using",
			"cannot-add-language": "This language is already added",
		},
	},
	article: {
		actions: {
			title: "Article actions",
			delete: {
				section: {
					title: "Delete section?",
					body: 'Section <strong style="font-weight: 500">{{title}}</strong> and nested articles {{count}} in it will be deleted.',
				},
				article: {
					title: "Delete article?",
					body: 'Article <strong style="font-weight: 500">{{title}}</strong> will be deleted.',
				},
				buttons: {
					primary: "Delete{{count}}",
					secondary: "Cancel",
				},
				"restore-from-trash": "You can restore it from the trash.",
			},
		},
		move: {
			"to-workspace": "Move",
			"create-new-catalog": "Create new catalog",
			"no-workspaces": "No other spaces",
			"no-catalogs": "No other catalogs",
			"cannot-move-language": "You can not move article out of catalog with multiple languages",
			"cannot-move-template": "You can not move article created from a template",
			progress: "Moving article",

			duplicate: {
				title: "This article already exists",
				description:
					"Article <code>{{articleName}}</code> already exists in the catalog <code>{{targetCatalogName}}</code>. You can either keep both or replace the existing article",
				"keep-both": "Keep Both",
				replace: "Replace",
				cancel: "Cancel",
			},
		},
		create: {
			title: "Create Article",
			body: "Your sections and articles will be in the left navigation. Start by creating your first article.",
		},
		title: "Article Title",
		"no-name": "Untitled",
		placeholder: "Article text",
		"add-child": "Add a sub-article",
		"add-root": "Add a root article",
		add: "Add article",
		"next-article": "Next article",
		"previous-article": "Previous article",
		links: {
			name: "Related articles",
			backlinks: "Backlinks",
			links: "Links",
			"no-links": "No links",
		},
		configure: {
			title: "Article settings",
			description: "Configure your article settings",
		},
		"edit-markdown": "Edit Markdown",
		"edit-markdown-disabled-template": "You can't edit the Markdown of a template article",
		"edit-markdown-disabled-not-current-item": "You can't edit the Markdown of a non-current article",
		"markdown-edit": {
			title: "Markdown Formatting",
			description: "Edit or define the article styling using Markdown",
		},
		error: {
			parse: {
				default:
					"Gramax couldn’t read the Markdown structure in the article file.\nFix the error or remove the structure.",
				web: "Gramax couldn’t read the Markdown structure in the article file.\nClick <a href=’?mode=markdown’>Edit Markdown</a>, then fix the error or remove the structure.",
			},
			"resource-too-large": {
				title: "Unable to add file",
				desc: "File size exceeds {{maxSizeMb}} MB. Compress it, select a smaller file, or use the desktop version.",
			},
			"not-found": {
				title: "Article not found",
				body: "The article was moved or deleted. Reload the page to get the updates.",
			},
			"render-failed": "Failed to display the article",
		},
		custom: {
			"404": {
				title: {
					article: "Article not found",
					catalog: "Catalog not found",
				},
				"alert-title": "Check that the path is correct",
				pathname: "Please ensure that the path `{{pathname}}` actually exists",
				"open-in-desktop":
					"You can also [open this path in Gramax desktop app](gramax://{{pathname}}) to edit on your computer",
			},
			"403": `---
title: 403
---

[alert:warning:This is a private article]\n\nLog in with an account that has access or request permissions from the author.\n\n[/alert]`,
			"500": {
				title: `---
title: Unable to display the article
---
`,
				body: `[alert:error:Gramax couldn’t read the Markdown structure in the article file]\n\nFix the error or remove the structure.\n\n[/alert]`,
				"body-browser": `[alert:error:Gramax couldn’t read the Markdown structure in the article file]\n\nFix the error or remove the structure in [Edit Markdown](?mode=markdown).\n\n[/alert]`,
			},
		},
	},
	section: {
		configure: {
			title: "Section Settings",
			description: "Configure your section settings",
		},
	},
	catalog: {
		actions: {
			title: "Catalog actions",
		},
		navigation: "Catalog navigation",
		new: "Create new",
		"new-2": "Create new catalog",
		"new-3": "Stored locally until first publication",
		clone: "Load",
		"clone-2": "Load existing",
		"clone-3": "Clone via Link",
		"clone-4": "From GitHub, GitLab or other storage",
		import: "Import",
		"import-2": "Import from another system",
		"import-3": "From Confluence or Notion",
		add: "Add catalog",
		views: {
			trigger: "Catalog view",
			editing: "Editing",
			"name-required": "Name is required",
			sections: {
				saved: "Saved",
				filters: "Filters",
				properties: "Variables",
			},
			"temp-view": "Temporary view",
			edit: {
				title: {
					new: "New view",
					edit: "Edit view",
				},
				description: {
					new: "Create a new view for your catalog",
					edit: "Edit the parameters of your view",
				},
				deleteDescription: "Are you sure you want to delete this view? This action cannot be undone.",
				form: {
					name: "Name",
					filter: "Filter",
					property: "Variables",
					options: {
						docportalVisible: {
							name: "Visible in docportal",
							description: "View will be visible and available for use on a documentation portal",
						},
					},
				},
			},
		},
		delete: {
			name: "Delete catalog",
			local: "This catalog is stored only in the app. You will not be able to restore it",
			storage: "The catalog will be deleted only from the app. But you can reload it from storage",
			progress: "Removing catalog",
		},
		move: {
			"unavailable-in-ges": "Cannot move catalog out of Enterprise space",
			"to-workspace": "Move",
			"no-workspaces": "No other spaces available",
		},
		duplicate: {
			title: "This catalog already exists",
			description:
				"Catalog <code>{{catalogName}}</code> already exists in the space <code>{{targetWorkspaceName}}</code>. You can either keep both or replace the existing catalog",
			"keep-both": "Keep Both",
			replace: "Replace",
			cancel: "Cancel",
		},
		name: "catalog",
		configure: "Configure catalog",
		"missing-config": {
			title: "Insufficient catalog information",
			description:
				"This catalog was not created in Gramax: it has no name, group, or logo. Specify them in the settings.",
			"open-settings": "Open settings",
		},
		"catalog-already-linked": {
			name: "Catalog already linked with repository",
			description:
				"We detected that the catalog is linked with a repository. But we don't know which storage this repository is located in. Add storage to confirm the link.",
		},
		style: {
			red: "Red",
			blue: "Blue",
			black: "Black",
			green: "Green",
			purple: "Purple",
			"blue-pink": "Blue-pink",
			"pink-blue": "Pink-blue",
			"blue-green": "Blue-green",
			"red-green": "Red-green",
			"orange-red": "Orange-red",
			"red-orange": "Red-orange",
			"blue-purple": "Blue-purple",
			"purple-blue": "Purple-blue",
			"dark-orange": "Dark-orange",
			"pink-purple": "Pink-purple",
			"orange-green": "Orange-green",
			"green-orange": "Green-orange",
			"bright-orange": "Bright-orange",
			"purple-orange": "Purple-orange",
			teal: "Teal",
		},
		"get-started": {
			editor: "With Gramax, you can create and edit documentation directly in the code repository. You can start in three ways:",
			"editor-desc":
				"<ul><li>Create a catalog in Gramax and publish it to GitLab or GitHub.</li><li>Load an existing repository.</li><li>Import a section from Confluence.</li></ul>",
			docportal: "Load catalogs that will be visible to readers",
		},
		error: {
			"already-exist": "Such a catalog already exists",
			"already-exist-2":
				"In storage % catalog % already exists.\nChange the “Repository Name” in the catalog settings.",
		},
	},
	share: {
		name: {
			catalog: "Share catalog",
			article: "Share article",
		},
		description: {
			catalog: "Share a link to the catalog with other users",
			article: "Share a link to the article with other users",
		},
		"new-file-disable": "You can share only after the article is published",
		copy: "Link to access the article and catalog on the branch ",
		hint: "You can also copy the link directly from your browser's address bar.",
		note: "Note:",
		desc: "<b>Note:</b> Make sure the recipient has access to the repository in {{domain}} via an <em>Access Token</em> with <code>read_api</code> and <code>write_repository</code> permissions.",
		more: "Learn more.",
		popover: "Copied to clipboard",
		error: {
			"no-private-groups": "No private groups set. Learn more https://docs.ics-it.ru/doc-reader/catalog/private",
			"need-permission": "Need access to the catalog",
			"incorrect-ticket": "Incorrect ticket",
			"failed-to-copy": "Failed to copy to clipboard",
		},
	},
	diagram: {
		modal: {
			"warning-have-changes": {
				title: "Leave the editor?",
				body: "Unsaved changes will be lost.",
				stay: "Stay",
				exit: "Exit",
			},
		},
		name: "Diagram",
		names: {
			mermaid: "Mermaid",
			puml: "PlantUml",
			drawio: "Diagrams.net",
		},
		error: {
			"render-failed": "Failed to render diagram",
			"cannot-get-data": "Check if the path is correct and if the diagram file is in the repository.",
			"no-diagram-renderer": "Diagram renderer module is not enabled",
			"no-internet": "Check your internet connection.",
			"invalid-syntax": "Check the diagram syntax.",
			"wrong-name": "Incorrect diagram name",
			"tabledb-render-failed": "Failed to display the table",
			"tabledb-file-not-found": "Error displaying item. Schema file not found at the path",
			"tabledb-not-found": "Error displaying item. Table not found",
			specification: "Failed to render specification",
			"content-empty": "Diagram file is empty",
			"mermaid-export-next-error": "Mermaid diagram will be rendered as diagram content",
		},
	},
	openApi: {
		loading: "Loading OpenAPI specification...",
		noSourceHint: "Set src or assign el.spec to render an OpenAPI document.",
		errorTitle: "Cannot display the OpenAPI specification",
		errorInvalidFormat: "The specification format is invalid.",
		errorTechnicalDetails: "Technical details",
		authorize: "Authorize",
		noResultsFound: "Nothing found",
		operationsHeading: "Operations",
		searchPlaceholder: "Search operations...",
		searchResultsCount: "{count} of {total}",
		searchClearAriaLabel: "Clear search",
		serverVariableUnused: "not in the URL",
		termsOfService: "Terms of service",
		contact: "Contact",
		externalDocs: "External docs",
		docsLinkFallback: "Docs",
		diagnosticsAriaLabel: "OpenAPI diagnostics",
		diagnosticsErrors: "Errors",
		diagnosticsWarnings: "Warnings",
		diagnosticsInfo: "Info",
		diagnosticPath: "Path",
		diagnosticExpected: "Expected",
		diagnosticReceived: "Received",
		diagnosticAction: "Action",
		diagnosticVersionUnsupported: "OpenAPI {received} is partially supported.",
		diagnosticResponsesMissing: "responses is missing; operation skipped.",
		diagnosticResponsesNotObject: "responses must be an object; operation skipped.",
		diagnosticExternalRefUnresolved: "$ref could not be resolved; fallback used.",
		diagnosticInternalRefUnresolved: "$ref could not be resolved; fallback used.",
		diagnosticOperationNotObject: "Operation must be an object and was skipped.",
		diagnosticPathItemNotObject: "Path item must be an object and was skipped.",
		diagnosticParametersNotArray: "Parameters must be an array; parameter block was skipped.",
		diagnosticParameterNotObject: "Parameter must be an object or $ref and was skipped.",
		diagnosticParameterNameNotString: "Parameter name should be a string; a fallback empty name is used.",
		diagnosticParameterLocationNotString:
			"Parameter location should be a string; a fallback empty location is used.",
		diagnosticParameterSchemaNotObject: "Parameter schema must be an object; rendered as an unknown schema.",
		diagnosticContentNotObject: "Content must be an object keyed by media type; content rendering was skipped.",
		diagnosticMediaTypeNotObject: "Media type entry must be an object and was skipped.",
		diagnosticMediaSchemaNotObject: "Media schema must be an object; the example view may still render.",
		diagnosticRequestBodyNotObject: "Request body must be an object or $ref and was skipped.",
		diagnosticResponseNotObject: "Response must be an object or $ref; rendered with fallbacks.",
		diagnosticResponseHeadersNotObject: "Response headers must be an object and were skipped.",
		diagnosticResponseLinksNotObject: "Response links must be an object and were skipped.",
		diagnosticSchemasNotObject: "components.schemas must be an object; the Schemas section was skipped.",
		diagnosticSchemaNotObject: "Schema entry must be an object and was skipped.",
		diagnosticSecuritySchemesNotObject: "Security schemes must be an object; authorization methods were skipped.",
		diagnosticSecuritySchemeNotObject: "Security scheme must be an object or $ref and was skipped.",
		diagnosticSecuritySchemeTypeInvalid:
			"Security scheme type is missing or invalid; the method cannot be applied.",
		diagnosticSecuritySchemeFieldInvalid: "Security scheme has a missing or invalid required field.",
		diagnosticSecurityRequirementsNotArray: "security must be an array; authorization requirements were skipped.",
		diagnosticSecurityRequirementNotObject: "Security requirement must be an object and was skipped.",
		diagnosticSecurityRequirementScopesNotArray: "Security requirement scopes must be an array and were ignored.",
		diagnosticSecurityRequirementUnknownScheme: "Security requirement references an undeclared scheme.",
		diagnosticVersionMissing: "OpenAPI version is missing; rendering continues in compatibility mode.",
		diagnosticInfoMissing: "The spec is missing an info object; a fallback title and version are used.",
		errors: {
			title: "Failed to display the OpenAPI specification",
			missing: "File «{path}» was not found. Check the path or recreate the component.",
			empty: "File «{path}» is empty. Open the spec editor (pencil) and fill it in.",
			invalidFormat: "The specification file has an invalid format.",
			syntax: "{format} syntax error: line {line}, column {column}.",
			structureObject: "The file does not look like an OpenAPI specification: its content must be an object.",
			structurePaths:
				"The file does not look like an OpenAPI specification: no paths section with API operations.",
			structurePathsObject:
				"The file does not look like an OpenAPI specification: paths must be an object with API operations.",
			structureOperations:
				"The file does not look like an OpenAPI specification: there are no valid API operations.",
			expected: "expected:",
			received: "received:",
			runtimeTitle: "Something went wrong",
			runtimeMessage: "Failed to render the block. The developers have already received an error report.",
		},
		permalink: "Permalink",
		permalinkTo: "Permalink to",
		deprecated: "deprecated",
		parametersTitle: "Parameters",
		requestTitle: "Request",
		curlTitle: "cURL",
		modeDescribe: "Overview",
		modeExecute: "Try it",
		requiredBadge: "required",
		paramColumnName: "Parameter",
		paramColumnDescription: "Description",
		paramColumnValue: "Value",
		paramDefaultLabel: "Default",
		paramExampleLabel: "Example",
		sendEmptyValue: "send as ?{name}=",
		deepObjectHint: "JSON object or key=value pairs; serialized as name[key]=value.",
		fieldColumnName: "Field",
		cookieParamsNotice: "Try does not send cookie parameters",
		cookieParamsNoticeDetail: "Entered values are included only in the generated curl command.",
		codeSamplesLabel: "Code samples",
		sampleFallbackLabel: "Sample",
		copyTitle: "Copy",
		contentTypeLabel: "Content type",
		exampleTab: "Example",
		schemaTab: "Schema",
		schemaAllowedValuesLabel: "Allowed values",
		schemaArrayItemsLabel: "Array items",
		schemaAdditionalPropertiesLabel: "Additional properties",
		schemaAdditionalPropertiesForbiddenLabel: "Not allowed",
		binaryTab: "Binary",
		requestBodyHeading: "Request body",
		binaryBodyHint: "Binary body is sent as a file/blob without JSON formatting.",
		plainBodyHint: "Plain body mode: content is sent as-is, without JSON quoting.",
		responsesHeading: "Responses",
		responseColumnCode: "Code",
		responseDefaultHint: "Any other HTTP status",
		noResponseBody: "No response body.",
		binaryResponseNotice: "Binary/download response. The preview does not print raw bytes as text.",
		formatLabel: "Format",
		headersLabel: "Headers",
		headerColumnName: "Header",
		headerColumnType: "Type",
		linksLabel: "Links",
		linkColumnName: "Link",
		operationColumnName: "Operation",
		linkedOperationFallback: "linked operation",
		parametersPrefix: "Target parameters:",
		requestBodyPrefix: "Target request body:",
		authorizationTitle: "Authorization",
		noAuthRequired: "No auth required.",
		noOauthFlowsDeclared: "No OAuth2 flows declared.",
		executeRequestButton: "Send",
		executeSendingButton: "Sending…",
		requiredFieldError: "Required field",
		requestFailedTitle: "Couldn’t get a response",
		requestFailedHint:
			"The API is unavailable or the request was blocked. Check the server URL or try the curl command above.",
		emptyResponseLabel: "(empty response)",
		binaryResponseSummary:
			"Binary response ({type}), {size} bytes. Download it outside this preview to save the file.",
		secretShow: "Show value",
		secretHide: "Hide value",
		requestDetailsLabel: "Request details",
		requestUrlLabel: "Request URL",
		resultHeading: "Response",
		statusLabel: "Status",
		clearButton: "Clear",
		bodyLabel: "Body",
		schemasSectionName: "Schemas",
		schemasSectionDesc: "OpenAPI component models",
		modelLabel: "Model",
		securitySchemesKicker: "Authorization method",
		closeLabel: "Close",
		noAuthLabel: "No auth",
		oauthFooterNote: "OAuth 2.0 sign-in is not supported. You can still view and copy its configuration below.",
		openIdConnectNote:
			"OpenID Connect sign-in is not supported. You can still view and copy its configuration below.",
		mutualTlsLabel: "Mutual TLS",
		mutualTlsNote:
			"Client certificates are managed by the browser or operating system and cannot be configured here.",
		httpAuthUnsupportedNote: "HTTP {scheme} credentials cannot be configured here.",
		authVariantUnsupportedNote: "Unavailable in Try",
		authVariantConflictNote: "These methods use conflicting request credentials and cannot be combined.",
		deprecatedAuthNote: "This authorization method is deprecated.",
		requiredScopesLabel: "Required scopes",
		availableScopesLabel: "Available scopes",
		bearerFormatLabel: "Token format",
		doneButton: "Save",
		bearerTokenLabel: "Bearer token",
		usernameLabel: "Username",
		passwordLabel: "Password",
		headerValueLabel: "API key",
		queryValueLabel: "API key",
		cookieValueLabel: "API key",
		apiKeyPlaceholder: "API key",
		apiKeyNameLabel: "Name",
		apiKeyLocationLabel: "Location",
		apiKeyHeaderHint: "Sent in the request header {name}.",
		apiKeyQueryHint: "Sent as query parameter {name}.",
		apiKeyCookieHint: "Added to curl as the {name} cookie. Try does not send cookie parameters.",
		apiKeyCookieRequestHint: "Sent in the request as the {name} cookie.",
		metadataOnlyNote: "Metadata only.",
		oauthMetadataOnlyNote: "OAuth2 metadata only. No flows declared.",
		paramTipQuery: 'Sent in the URL query string after "?", e.g. ?page=1',
		paramTipPath: "Substituted directly into the URL path, e.g. /users/42",
		paramTipHeader: "Sent in the HTTP request header",
		paramTipCookie: "Sent in the request cookie",
		serverLabel: "Server",
		baseUrlLabel: "Base URL",
		serverVariablesLabel: "URL variables",
		operationServersLabel: "Base URL for this operation",
		relativeUrlFallback: "relative",
		serverSelectAriaLabel: "Server",
		untaggedGroupLabel: "Untagged",
		specSwitcherAriaLabel: "OpenAPI specification",
		otherTagsLabel: "Other tags",
		swagger2HostLabel: "Swagger 2.0 host",
	},
	"open-in": {
		web: "Open in web app",
		desktop: "Open in app",
		gramax: "Edit in Gramax",
		generic: "Open in",
		teams: "Open in Teams",
		finder: "Show in Finder",
		explorer: "Show in Explorer",

		error: {
			"cannot-open-desktop": {
				title: "App not installed",
				desc: "<a target='_blank' rel='noreferrer' href='https://gram.ax'>Download the app</a><span> and try again.</span>",
			},
		},
	},
	"enterprise-guest": {
		welcomeTitle: "Welcome to Gramax!",
		privateTitle: "Sign in to continue",
		privateDescription: "This article is only available to authorized users",
		"session-expired": "Your session has expired. Sign in again.",
		descriptions: {
			emailFieldDescription: "Enter your email to receive a one-time code",
			otpFieldDescription: "Enter the code sent to your email",
			continueWith: "or continue with",
		},
		placeholders: {
			emailPlaceholder: "johndoe@example.com",
			otpPlaceholder: "123456",
		},
		buttons: {
			sendPasswordButton: "Send code",
			resendPasswordButton: "Resend code",
			confirmButton: "Confirm",
			resendPasswordButtonWithCooldown: "Resend code in {seconds} sec",
			corporateLoginButton: "Sign in with SSO",
		},
		fields: {
			emailLabel: "Email",
			otpLabel: "Access code",
		},
		validationErrors: {
			emailRequired: "Email is required",
			emailInvalidFormat: "Invalid email format",
			edgeWhitespace: "Email contains whitespace. Please recreate the record.",
			otpRequired: "Code is required",
			otpNumbersOnly: "Code must contain only numbers",
			otpLength: "Code must be 6 digits long",
			formSubmitError: "Please fill all required fields correctly",
		},
		tooltips: {
			tooManyRequests: "Too many requests. Try after {minutes} min",
			resendAvailableIn: "Resend available in {seconds}",
			internalServerError: "Internal server error. Please try again later",
			loginFailed: "Login failed (Status: {status})",
			errorSendingPassword: "Error sending code (Status: {status})",
			invalidOtp: "Invalid code",
			networkError: "Network error. Please try again",
		},
	},
	"enterprise-cloud-guest": {
		buttons: {
			continueWithGoogle: "Continue with Google",
			continueWithYandex: "Continue with Yandex",
			continueWithoutAccount: "Continue without account",
		},
		description: "Sign in to sync across devices and collaborate",
	},
	cloud: {
		"publish-to-cloud": "Publish to Cloud",
		"login-modal": {
			title: "Sign in to Gramax Cloud",
			description: "Authorization is required to publish the catalog",
			definition:
				"is a service for hosting static HTML versions of catalogs. After publishing, your catalog will be available at the following link",
			"account-info":
				"Sign in is required to protect and link the publication to your account. All subsequent publications will also be performed on behalf of this account.",
		},
		"upload-modal": {
			title: "Publish catalog",
			description: "Make your catalog available to everyone",
			info: "After publishing, the catalog will become available <strong>to everyone on the Internet</strong> at the following link:",
			revoke: "You can unpublish the catalog at any time.",
			"switch-account": "Switch account",
			status: {
				building: "Building site",
				publishing: "Publishing",
				error: "Publishing failed",
			},
			published: {
				title: "Republish catalog",
				description: "Update the published catalog available to everyone",
				info: "After republishing, the catalog will remain available <strong>to everyone on the Iinternet</strong> at the following link:",
			},
		},
		"uploaded-modal": {
			title: "Catalog published successfully",
			link: "Link to the published catalog",
			description:
				"You can see the publication status in the right panel. There you can also update or revoke the publication.",
		},
		"publish-status-panel": {
			published: "Published",
			republish: "Republish",
			delete: "Delete publication",
		},
		error: {
			"failed-to-connect": "Failed to connect to the cloud server",
			"request-failed": "Failed to request to the cloud server",
		},
		"delete-catalog": "The catalog will be deleted from cloud",
	},
	"log-in": "Log in to ",
	"login-with": "Login with ",
	search: {
		name: "Search",
		open: "Open search",
		"search-in-article": "Search in this article",
		"search-in-category": "Search in this section",
		placeholder: "Enter query",
		"articles-not-found": "No articles found",
		"all-catalogs": "Search all catalogs",
		ai: "AI search",
		"ai-search-error":
			"The AI search function is unavailable due to technical problems. We recommend contacting the system administrator for additional information.",
		"ai-search-error-title": "Technical problems with AI search",
		"indexing-info": "Indexing...",
		"hidden-results": "...{{count}} more",
		recommended: "Recommended",
		current: "Current article",
		"property-filter": {
			tooltip: "Property filter",
			"reset-all": "Reset all",
			selected: "Selected",
		},
		"resource-filter": {
			"with-resources": "With files",
			"without-resources": "Without files",
			"only-resources": "Only in files",
			tooltip: "Search in files",
		},
		"scope-filter": {
			all: "In all catalogs",
			catalog: "In this catalog",
			article: "In this article",
			category: "In this section",
			folder: "In this folder",
			tooltip: "Search scope",
		},
		help: {
			ai: {
				title: "Smart search",
				description: "Finds answers in the knowledge base by meaning, not by exact keyword match",
			},

			title: "Search more precisely",

			"exact-desc": "Exact match",
			"exact-example": `"phrase"`,

			"exclude-desc": "Without this word",
			"exclude-example": `-word`,

			"include-desc": "Must include this word",
			"include-example": `+word`,

			"combine-desc": "Combine them",
			"combine-example": `+setup -"word"`,
		},
	},
	list: {
		"no-results-found": "No results found",
		"search-articles": "Enter link or search for articles",
		"search-catalogs": "Enter link or search for catalogs",
	},
	versions: {
		name: "Versioning",
		description: "Multiple versions of a catalog based on Git branches or tags with switching between them.",
		switch: "Switch version",
		version: "Version",
		"not-actual-warning": {
			header: "Outdated version",
			"1": "You are viewing an outdated version ",
			"2": "Switch to the <a data-qa href='{{link}}'>latest version</a> to view the actual version",
		},
	},
	filterProperties: {
		switch: "Filter",
		unfilter: "No filter",
		hasProperty: "Has property",
		value: "Value",
	},
	git: {
		source: {
			gitlab: {
				info: `Token for reading and modifying repositories in storage. Specify the token permissions: <code>api</code>, <code>read_repository</code>, <code>write_repository</code>.`,
			},
			gitverse: {
				info: `Token for reading and modifying repositories in storage. Specify the token permissions: <code>Репозитории</code>, <code>Пользователи</code>.`,
			},
			gitea: {
				info: `Token for reading and modifying repositories in storage. Specify the token permissions: <code>repository</code>, <code>user</code> (Read and Write).`,
			},
			error: {
				"cannot-create-repo": "Unable to create repository",
				"storage-not-exist": 'Storage named "{{storage}}" does not exist. Add it.',
				"catalog-exist":
					"In storage {{storage}} catalog {{name}} already exists.\nChange the “Repository Name” field in the catalog settings.",
				"cannot-bind-to-storage": `Cannot bind to this storage`,
				"unsupported-link": "A link of the format must be specified",
				"invalid-credentials": {
					desc: "The current token for this storage is invalid. Update the storage data and try again.",
				},
				"invalid-credentials2": "Invalid storage data",
			},
			"remove-alert": "Are you sure you want to delete this source?",
			"remove-alert-usage": "It is used in the following catalogs:\n\n",
		},
		clone: {
			progress: {
				finish: "Downloaded",
				downloading: "Downloading",
				checkout: "Checking out",
				wait: "Waiting server",
				queue: "Pending",
				cancel: "Cancelling",
			},
			etc: {
				bs: "{bs} B/s",
				kbs: "{kbs} KB/s",
				mbs: "{mbs} MB/s",
				b: "B",
				kb: "KB",
				mb: "MB",
				gb: "GB",
				"eta-s": ", ETA {s}s",
				"eta-m": ", ETA {m}m {s}s",
				"eta-h": ", ETA {h}h {m}m {s}s",
			},

			"receiving-objects": "Received {received} objects of {total} (indexed {indexed})",
			"indexing-deltas": "Indexed {indexed} deltas of {total}",
			lfs: "Downloaded {handledObjects} of {totalObjects} LFS objects ({bytesHandled} / {totalBytes})",
			checkout: "Checkout {checkouted} files of {total}",
			"repo-link": "Repository link",
			"public-clone": "Clone via Link",
			"not-cloned": {
				title: "Load catalog?",
				body: "The link leads to a catalog that has not been loaded yet. To view and edit, load it from storage.",
			},
			"open-in-app": "You also can open that catalog in Gramax desktop app",
			public: {
				"link-title": "Repository URL",
				"link-placeholder": "Public Git Repository URL",
				"link-description": `Public Git Repository URL to clone.<br>For example: <a href='https://github.com/gram-ax/gramax' ${
					getExecutingEnvironment() === "tauri" ? "" : "target=_blank"
				} rel='noreferrer'>https://github.com/gram-ax/gramax</a>`,
			},
			error: {
				title: "Error loading",
				"cannot-clone": "Unable to load catalog",
				"already-exist": "A catalog with name `{{path}}` already exists",
				"no-permission": "No access to repository {{url}}",
				generic: "Try refreshing the page and loading the catalog again.",
				"branch-not-found": "Unable to load catalog on branch <code>{{branch}}</code>",
				public: {
					"invalid-link":
						"Invalid link to repository. Please check if link is correct and repository is public",
					"name-empty": "Repository name and url cannot be empty",
				},
			},
		},
		sync: {
			error: {
				"local-changes-present": "Your local changes prevent synchronization",
				"no-permission": "You don't have permission to synchronize with this catalog",
				"at-revision":
					"Synchronization and publishing in history of changes are not available — return to the current version.",
			},
		},
		checkout: {
			"change-branch": "Change branch",
			conflict:
				"The current branch has unpublished changes that conflict with changes in another branch. Please publish or revert them.",
			"pathname-desc":
				"If you have unpublished changes and they don't conflict with changes in another branch, they will be carried over.",
			error: {
				"local-changes-present": "Your local changes prevent branch switching",
				conflict: "Unable to switch branch",
				"conflict-diagnosis": "The current branch has unpublished changes. Your changes are saved locally.",
				"conflict-recipe": "Publish or discard the changes, then try switching branches again.",
			},
		},
		branch: {
			management: "Branch management",
			current: "Current branch",
			actual: "Actual branch",
			create: "Create branch",
			actions: "Branch actions",
			error: {
				"deleting-head-branch":
					"You are trying to delete the branch you are on. Switch to another branch and try again",
				"cannot-delete-protected":
					"Branch <code>{{branch}}</code> is protected from deletion. Uncheck the “Delete branch <code>{{branch}}</code> after merging” option and try again",
				"cannot-delete":
					"Failed to complete the deletion of the published branch <code>{{branch}}</code>. Please reload the page and try again",
				"not-found": {
					local: "Could not determine the current branch",
					remote: "Failed to find remote branch for local branch <code>{{branch}}</code>",
					default: "Can't find default branch to checkout",
				},
				"not-found-reload": "Could not determine the current branch. Reload the page",
				"already-exist": "Unable to create new branch. Branch <code>{{branch}}</code> already exists",
				"has-been-deleted": {
					title: "Branch has been deleted",
					body: "The branch on which the catalog was located has been deleted. You will be switched to the default branch of the catalog",
				},
			},
			delete: {
				confirm: {
					title: "Delete branch?",
					description:
						"Branch <code>{{branch}}</code> and all its content will be deleted from the app and the Git storage. This action cannot be undone",
				},
			},
		},
		merge: {
			title: "Merge branches",
			"instant-merge": "Instant merge",
			merge: "Merge",
			"add-user": "Add user",
			branches: "Merge branches",
			"after-merge": "After the merge",
			"current-branch": "Merge the current branch",
			"delete-branch-after-merge": "Delete branch after merge",
			squash: "Squash commits",
			"squash-tooltip": "Changes from the current branch will be squashed into a single commit after merging",
			conflict: {
				conflicts: "Conflicts",
				"abort-confirm": {
					title: {
						sync: "Cancel synchronization?",
						branch: "Undo branch merge?",
					},
					body: {
						sync: "A conflict occurred during synchronization. You need to resolve it to complete synchronization. If you do not, the catalog will return to its previous state.",
						branch: "A conflict occurred while merging branches. You need to resolve it to complete the merge. If you don't, the merge will be canceled.",
						"impossible-conflict":
							"A conflict occurred while merging branches. Reload the page and resolve the conflict.",
					},
					"action-button": {
						sync: "Cancel synchronization",
						branch: "Cancel merge",
					},
					"cancel-button": "Resolve the conflict",
				},
				"current-change": "Current change",
				"incoming-change": "Incoming change",
				"accept-current-change": "Keep current change",
				"accept-incoming-change": "Select incoming change",
				"accept-both": "Select both changes",
				"delete-in-current":
					"The file was deleted in the current revision but changed in the incoming revision",
				"delete-in-incoming":
					"The file was changed in the current revision but deleted in the incoming revision",
				"default-with-deletion-text": "The file was removed or added in the current or incoming change.",
				leave: "Leave",
				"added-by-them": "You do not have a file that was added or renamed in the incoming change.",
				"added-by-us": "You added or renamed a file that was not in the incoming change.",
				"deleted-by-them": "You modified a file that was deleted or renamed in the incoming change.",
				"deleted-by-us": "You deleted or renamed a file that was changed in the incoming change.",
				resolver: {
					title: "Resolve conflict",
					description: "Select files and resolve merge conflicts",
				},
			},
			confirm: {
				sync: "You have unpublished changes that conflict with changes in the live branch. Resolve the conflict before syncing.",
				branch: "Changes in branches conflict. Resolve the conflict before merging.",
				"catalog-conflict-state":
					"Your catalog is in a state of conflict. Resolve the conflict before you continue editing.",
				"catalog-conflict-state-with-checkout":
					"<p>The link leads to the <code>{{branchToCheckout}}</code> branch, but your catalog is in conflict. Resolve the conflict before you continue editing.</p>",
			},
			error: {
				sync: "Failed to synchronize changes",
				generic: "Failed to merge branches",
				branches: "Failed to merge branches",
				"workdir-not-empty": {
					title: "You have local changes",
					body: "Publish or discard local changes. After that, merge the branches.",
				},
				"not-supported": "Merge error. We cannot resolve such conflicts yet",
				"conflict-occured": "Could not automatically resolve merge conflict",
				"conflicts-not-found": "Failed to get conflicting files",
				"catalog-conflict-state": "Resolve the conflict",
				"merge-request-exists": "Cannot create a merge request because it already exists",
				"merge-request-instant-merge": "Cannot merge branches because a merge request already exists",
			},
		},
		publish: {
			"empty-state": {
				title: "No changes",
				description: "Changed files will appear here once you start editing",
			},
			name: "Publish",
			"to-publish": "Publish",
			error: {
				"non-fast-forward": {
					title: "Outdated catalog version",
					body: "The server has newer changes. Synchronize, then publish again.",
				},
				unknown: "Unknown error when publishing. Error message -",
				protected: "Branch protected from publishing",
				"protected-branch": "Protected branch",
				"protected-branch-description":
					"Publishing directly to a protected branch is not allowed. To make changes, create a new branch and merge it, or create a merge request.",
				"direct-publish-forbidden": "Direct publishing is prohibited.",
				"create-branch-and-merge": "Create a new branch and merge it",
				"resolve-conflicts": "Resolve conflicts",
				"has-conflicts-description":
					"You can't publish right now. There are conflicts that need to be resolved first.",
				"no-permission": "You do not have permission to publish in this catalog",
				"permissions-unavailable": "Unable to verify access permissions. Please try again.",
				"main-branch": "Publishing in this branch is prohibited",
				"at-revision": "Publishing in history of changes is not available — return to the current version.",
			},
		},
		history: {
			"empty-state": {
				title: "History is empty",
				description: "Changes will appear here\nafter you publish for the first time",
			},
			name: "History",
			modal: {
				title: "Article history",
				description: "View the history of changes to the article",
			},
			filters: {
				title: "Filter",
				reset: "Reset all",
				cancel: "Cancel",
				apply: "Apply",
				"all-authors": "All authors",
				date: {
					title: "Period",
					placeholder: "dd.mm.yy",
					"range-placeholder": "dd.mm.yy — dd.mm.yy",
					today: "Today",
					"7-days": "7 days",
					"30-days": "30 days",
					"all-time": "All time",
				},
				authors: { title: "Author", placeholder: "Search author..." },
				articles: { title: "Articles" },
			},
			revisions: {
				title: "Compare revisions",
				reset: "Reset",
				"pick-a-commit": "Pick a commit",
				combined: "Combined",
				hint1: "Select two commits from the list",
				hint2: "to see changes between them",
			},
			button: "Show history",
			error: {
				empty: "No changes found",
				"not-found": "Could not find file history",
				"need-to-publish": "Change history will be available after the article is published",
			},
		},
		revisions: {
			"go-to-revision": "Go to revision",
			"compare-title-catalog": "Change review",
			"compare-title-article": "Article history",
			"compare-button": "Change review",
			"open-catalog-compare": "Open catalog on compare",
			"choose-placeholder": "Select revision...",
			"n-more": ", {count} more",
		},
		discard: {
			"select-all-arrow-tooltip": "Discard selected changes",
			"selected-file-arrow-tooltip": "Discard changes",
			"paragraph-tooltip": "Discard changes",
			alert: {
				title: "Discard selected changes?",
				body: "Articles will revert to their previous version, and the new media files will be deleted.",
				buttons: {
					primary: "Discard {count}",
					secondary: "Cancel",
				},
			},
		},
		"lfs-migration": {
			alert: {
				title: "Files need to be moved to new storage",
				body: "Storage rules for large files in this catalog have changed. Gramax will move them once automatically — your edits and texts are safe.",
				affected: "Files to move: {count} · {size} total",
				"details-trigger": "Technical details",
				"details-lead": "{file} changes: ",
				"details-added": "added to LFS —",
				"details-removed": "removed from LFS —",
				"details-directions":
					"The migration goes both ways: files under the new masks move into LFS, files under the removed ones are downloaded and put back into git. It is recorded as a separate service commit and stays out of your own changes.",
				migrate: "Move files",
				later: "Remind me later",
				migrating: "Moving files to storage…",
				footnote: "If you postpone, the dialog will reappear on the next sync",
			},
		},
		"lfs-auto-attachments": {
			alert: {
				title: "Move attachments to Git LFS?",
				body: "Every attachment referenced by this catalog's articles will be moved to Git LFS. The move is recorded as a separate service commit — your edits and texts are not affected.",
				affected: "Files to move: {count} · size: {size}",
				"details-trigger": "Technical details",
				"details-lead": "{file} will change: ",
				"details-added": "added to LFS",
				migrate: "Move files",
				cancel: "Cancel",
				migrating: "Moving files to storage…",
			},
		},
		warning: {
			"no-changes": {
				title: "No changes",
				body: "There are no changes in the current catalog to publish.",
			},
		},
		error: {
			"not-found": {
				branch: "Failed to find branch <code>{{what}}</code>",
				"remote-branch": "Failed to find remote branch <code>{{what}}</code>",
				blob: "Failed to find file <code>{{path}}</code>",
				repo: {
					title: "Repository not found",
					message: `Failed to find repository <a href='{{url}}' ${
						getExecutingEnvironment() === "tauri" ? "" : "target=_blank"
					} rel='noreferrer'>{{name}}</a> in Git storage. It may have been deleted, moved, or you don't have enough permissions to access it`,
				},
				generic: "Error code - NotFoundError. Error message - ",
			},
			broken: {
				tooltip: "Repository may be damaged",
				healthcheck: {
					title: "Repository may be damaged",
					body: "This catalog may be unstable",
					body2: "We recommend saving your changes and recovering the repository",
					"download-zip": "Save as ZIP",
					recover: {
						button: "Recover",
						confirm: {
							title: "Recovering",
							description:
								"Recovering will result in the loss of all local branches. Although your changes in working directory will be saved",
						},
					},
					ignore: {
						button: "Ignore",
						confirm: {
							title: "Ignoring error",
							description: "Be sure you know what you are doing. This may lead to unexpected behavior",
						},
					},

					"technical-details": "details",
				},

				"clone-failed": {
					title: "Failed to clone catalog",
					body: "An unexpected error occurred while loading the catalog. You can try to load it again or delete it",
					"technical-details": "Technical details",
					clone: {
						button: "Clone",
						title: "Clone catalog",
						description: "Are you sure you want to clone the catalog?",
					},
					delete: {
						button: "Delete",
						title: "Delete catalog",
						description:
							"Are you sure you want to delete the catalog? You will be able to reload it from storage",
					},
				},
			},
			"content-too-large": {
				title: "Too many changes",
				message: `You are trying to push a large file or too many changes at once. Try publishing changes by parts`,
			},
			"disk-full": {
				title: "Not enough disk space",
				message:
					"There is not enough free space on your disk to complete this operation. Free up some space and try again.",
			},
			network: {
				title: "Unable to connect to the server",
				message:
					"Publishing, synchronizing, changing branches, and other operations need access to the Git storage server. Check your connection and try again. If the problem persists, the server may be temporarily unavailable, or your network — a corporate proxy or VPN, say — may be blocking it. This is not about access rights or your token.",
			},
			http: {
				title: "Error when requesting Git storage",
				message: "An unexpected error occurred when requesting the Git repository",
			},
			checkout: {
				"invalid-path": {
					title: "File name not valid on Windows",
					message:
						'The operation failed: a file name contains characters not allowed on Windows (e.g. quotes ", *, ?, <, >, :, |). Rename the file from Linux/macOS or via the GitLab web IDE and try again.\n\nFile: {{path}}',
					"message-generic":
						'The operation failed: one of the files has a name not valid on Windows (e.g. it contains quotes ", *, ?, <, >, :, |, or the path is too long). Rename the file from Linux/macOS or via the GitLab web IDE and try again.',
				},
			},
		},
		"merge-requests": {
			"empty-state": {
				title: "No merge request",
				description: "Create a merge request from the branch list to see it here",
			},
			"branch-tab-tooltip": "This branch has a merge request",
			"branch-tab-badge": "MR",
			diff: "Changes",
			"advanced-mode": "Advanced mode",
			"advanced-mode-description": "Detailed info about added/deleted lines and article resources",
			approvedCountTooltip: "{{approvedCount}} of {{approvedTotal}} approvals",
			changes: "Changes",
			back: "Back",
			create: "Create merge request",
			"create-request": "Create request",
			by: "By",
			into: "into",
			you: "You",
			name: "Merge Request",
			approvers: "Reviewers",
			approvers2: "reviewers",
			"no-approvers": "No reviewers",
			"approved-of": "Approved",
			of: "of",
			approval: {
				approved: "Approved",
				unapproved: "Pending review",
				"publish-tooltip": "Approval takes effect only after you publish the changes",
			},
			status: {
				draft: "Draft",
				"draft-tooltip": "Waiting for merge request to be pushed to remote",
				"in-progress": "Review",
				"in-progress-tooltip": "Waiting for review and approval",
				approved: "Approved",
				"approved-tooltip": "Approved by all reviewers and ready to merge",
			},
			"disable-button-reason": {
				"has-conflicts": "Conflicts need to be resolved before merging branches",
				draft: "Can't merge a draft",
				"not-approved": "All reviewers need to approve",
				"not-author": "You are not the author of this merge request",
			},
			"delete-confirm": {
				title: "Delete merge request?",
				body: "The merge request will be deleted for all users after the changes are published",
			},
			confirm: {
				title: "Merge branches?",
				body: {
					"delete-branch-after-merge":
						"<p>Changes from the <code>{{sourceBranch}}</code> branch will be merged into the <code>{{targetBranch}}</code> branch, and branch <code>{{sourceBranch}}</code> will be deleted. This action cannot be undone.</p>",
					"not-delete-branch-after-merge":
						"<p>Changes from the <code>{{sourceBranch}}</code> branch will be merged into the <code>{{targetBranch}}</code> branch. This action cannot be undone.</p>",
					"squash-comment":
						"<p>The commits from the <code>{{sourceBranch}}</code> branch will be squashed and merged into the <code>{{targetBranch}}</code> branch. This action cannot be undone.</p>",
					"squash-delete-branch-comment":
						"<p>The commits from the <code>{{sourceBranch}}</code> branch will be squashed and merged into the <code>{{targetBranch}}</code> branch, and the <code>{{sourceBranch}}</code> branch will be deleted. This action cannot be undone.</p>",
				},
			},
			warning: {
				"no-changes": {
					title: "No changes",
					body: "There are no changes in branches to merge.",
				},
			},
			error: {
				"merge-with-conflicts": {
					title: "Failed to merge branches",
					body: "<p>There are conflicts in the branches. Merge the changes from the <code>{{targetBranch}}</code> branch into the <code>{{sourceBranch}}</code> branch. Then resolve the conflict.</p>",
				},
			},
		},
		"connect-source": {
			error: {
				"unable-to-connect": "Unable to connect to git server",
			},
		},
		lfs: {
			"file-is-pointer-2": "This file is stored in Git LFS and needs to be fetched, try syncing the catalog",
			"file-is-pointer": "This file is stored in Git LFS and needs to be fetched first. Try syncing the catalog",
		},
	},
	confluence: {
		blogs: "Blogs",
		"link-board": "Link to board",
		error: {
			"ext-not-supported": "Extension not supported:",
			http: "HTTP Error:",
			"couldnt-find-file": "Could not find file name:",
			"couldnt-find-fileId": "Could not find attachment with fileId:",
			"http-2": "HTTP Error while loading file:",
		},
	},
	import: {
		modal: {
			title: "Import catalog",
			description: "Select a source for import",
			load: "Import",
			"add-new-source": "Add new source",
			props: {
				source: {
					name: "Source",
					placeholder: "Select source",
				},
			},
		},
		error: {
			"page-conversion": "Error converting page",
			"ext-not-supported": "Extension not supported:",
			"source-required": "Source is required",
			"space-required": "Space is required",
			"cannot-import": {
				title: "Failed to import element from ",
				desc: "You can manually transfer it from the page",
			},
		},
	},
	diff: {
		modes: "Display modes",
		"source-text": "Source text",
		"double-panel": "Double panel",
		"file-too-large-for-preview": "File exceeds 1 MB and cannot be displayed",
		"unknown-extension": "Preview is not supported for this file type",
		type: {
			added: "Added",
			modified: "Modified",
			deleted: "Deleted",
			breadcrumb: "Article moved",
		},
		"previous-version": "Previous version",
		discard: "Discard",
	},
	"unsupported-elements": {
		confluence: {
			title: "Some elements will not be migrated",
			description:
				"Gramax does not support specific elements from Confluence, such as Jira tasks, graphs, and reports. You can migrate data from them manually.",
			noteTitle: "List of pages with unsupported elements",
		},
		notion: {
			title: "Some elements will not be migrated",
			description:
				"Gramax does not support specific elements from Notion, such as buttons, breadcrumbs. You can migrate data from them manually.",
			noteTitle: "List of pages with unsupported elements",
			"region-restricted": {
				title: "Access restricted",
				message:
					"Unfortunately, your request cannot be processed because access to Notion is restricted for your region.",
			},
		},
		default: {
			title: "Some elements will not be migrated",
			description:
				"Gramax does not support certain elements from the data source. You can migrate data from them manually.",
			noteTitle: "List of unsupported elements",
		},
	},

	alert: {
		details: "Details",
		image: {
			unavailable: "Failed to display the image",
			path: "Check that it exists and the path is correct.",
		},
		gif: {
			unavailable: "Failed to display the gif",
		},
		video: {
			unavailable: "Failed to display the video",
			path: "Check that the video at the link exists and is accessible to everyone on the internet.",
		},
	},
	editor: {
		"at-revision": "Editing in history of changes is not available — return to the current version.",
		diff: "View changes",
		ai: {
			improve: "Improve writing",
			generate: "Generate",
			transcribe: "Transcribe speech to text",
			discuss: "Discuss in chat",
		},
		italic: "Italic",
		bold: "Bold",
		stroke: "Strikethrough",
		property: "Variable",
		code: "Code line",
		question: {
			name: "Question block",
			placeholder: "Question title",
			required: "Required question",
			types: {
				name: "Question type",
				one: "One answer",
				many: "Multiple answers",
				text: "Free answer",
			},
			answer: {
				add: "Add answer",
				check: "Check",
				checking: "Checking...",
				placeholder: "Answer to the question",
			},
		},
		"code-block": "Code block",
		lists: "Lists",
		"bullet-list": "Bullet",
		"ordered-list": "Numbered",
		"task-list": "Tasks",
		note: "Note",
		notes: "Notes",
		heading: "Heading",
		attachments: "Attachments",
		tools: "Tools",
		"keys-and-passwords": {
			name: "Keys and passwords",
			empty: "No keys or passwords yet",
			fields: {
				login: "Login",
				password: "Password",
				token: "Token",
				url: "URL",
			},
		},
		modes: {
			view: "View",
			tabs: {
				article: "This article",
				catalog: "All catalog",
			},
			"mark-as-read": "Mark all as read",
			comments: "Comments review",
			"empty-state": {
				title: "No comments yet",
				description: "Select text in the article to leave the first comment",
			},
			counter: {
				unread: "Unread",
				total: "Total",
			},
			"search-placeholder": "Search comments...",
			"source-text": "Source text",
			"type-filter": {
				all: "All",
				comments: "Comments",
				changes: "Changes",
				unread: "Unread",
			},
			sorting: {
				title: "Sorting",
				order: "Order",
				none: "No sorting",
				newest: "Newest first",
				oldest: "Oldest first",
			},
			grouping: {
				title: "Grouping",
				none: "No grouping",
				article: "By article",
				date: "By date",
			},
			filters: {
				title: "Filters",
				reset: "Reset all",
				"all-authors": "all authors",
				date: {
					title: "Period",
					placeholder: "dd.mm.yy",
					"range-placeholder": "dd.mm.yy — dd.mm.yy",
					presets: {
						today: "Today",
						"7-days": "7 days",
						"30-days": "30 days",
						"all-time": "All time",
					},
				},
				authors: { title: "Author", placeholder: "Search author..." },
			},
		},
		float: {
			name: "Align",
			left: "Align to left",
			center: "Align to center",
			right: "Align to right",
		},
		highlight: {
			name: "Highlight background",
			colors: {
				yellow: "Yellow",
				green: "Green",
				purple: "Purple",
				blue: "Blue",
				orange: "Orange",
				red: "Red",
			},
		},
		templates: {
			"inline-property": "Property field",
			"block-field": "Block field input",
		},

		link: {
			"other-catalogs": "Other catalogs",
			"current-catalog": "Current catalog",
			catalogs: "Catalogs",
		},

		table: {
			name: "Table",
			row: {
				title: "Header row",
				"add-up": "Insert row above",
				"add-down": "Insert row below",
				"add-left": "Insert column left",
				"add-right": "Insert column right",
				delete: "Delete entire row",
			},
			column: {
				title: "Header column",
				delete: "Delete entire column",
			},
			align: {
				name: "Alignment",
				left: "Align to left",
				center: "Align to center",
				right: "Align to right",
			},
			"join-cells": {
				action: "Join cells",
				sorted: "Merging cells is not available while sorting",
			},
			"split-cells": "Split cells",
			aggregation: {
				name: "Aggregation",
				methods: {
					sum: { name: "SUM", tooltip: "" },
					avg: { name: "AVG", tooltip: "" },
					min: { name: "MIN", tooltip: "" },
					max: { name: "MAX", tooltip: "" },
					count: { name: "COUNT", tooltip: "Number of values in the column." },
					countDistinct: {
						name: "DISTINCT COUNT",
						tooltip: "Number of distinct values in the column.",
					},
				},
			},
			sort: {
				asc: "Ascending",
				desc: "Descending",
				"not-available": "Sorting is not available when merged cells are present",
			},
			save: "Save selected filters and sorting",
		},

		tabs: {
			name: "Tab",
			add: "Add new tab",
			delete: "Delete tab",
			"empty-placeholder": "Tab content",
			"delete-last": "You are deleting the last tab. Delete the entire element?",
		},

		video: {
			name: "Video",
			link: "Video link",
			"will-be-here": "Your video will be here",
			"not-available": "Video unavailable",
			error: {
				none: "Specify the link in the additional panel and add a caption.",
				"none-2": "Supported services: YouTube, Google Drive, Rutube, ",
				"none-2-link": "and others",
				some: "Check for video availability in the file storage at",
				"some-link": " link",
				"some-2": "Ensure there are no access restrictions for the video/link in the storage.",
				generic: "Check the file name is correct.",
				"generic-2": "Ensure the video is in the appropriate SharePoint folder. Learn where to place the file",
				"generic-2-link": " here",
			},
		},
	},
	"bug-report": {
		name: "Report a Bug",
		"what-happened": "What happened",
		"what-will-be-sent": "What will be sent?",
		describe: "Describe the issue",
		"attach-tech-details": "Share details",
		"this-will-help-us":
			"This information will help us fix the bug faster. We will not see your content or personal data. ",
		"tech-details": "Technical details",
		"tech-details-description": "The following data will be sent together with the bug report.",
		modal: {
			title: "Report a Bug",
			description: "Report a bug to help us fix it faster.",
		},
		error: {
			"cannot-send-feedback": {
				title: "Failed to send a feedback",
				message: "You may have an ad blocker enabled. Disable it and try again.",
			},
		},
	},
	word: {
		"table-of-contents": "Table of Contents",
		"error-rendering": "Error: Failed to render ",
		diagram: "diagram",
		picture: "picture",
		tabledb: "database table",
		fragment: "fragment",
		video: "video",
		error: {
			"export-type-error": "Error, no such export type: ",
			"canvas-to-blob-error": "Failed to convert canvas to Blob.",
			"canvas-error": "Failed to get canvas context.",
			"load-image-error": "Failed to load image.",
			"file-not-found-error": "File not found at path.",
			"wrong-object-type": "Error, no such object type.",
			"divide-by-zero-error": "Divide by zero error.",
			"delete-failed-error": "Failed to delete the file",
		},
		template: {
			templates: "Templates",
			"no-template": "No template",
			error: {
				"template-not-found": "Template not found",
				"processing-error": "Error during document processing",
			},
		},
	},
	pdf: {
		"component-parsing-failed": "Failed to process the component",
		"kanban-view-export-error": "The Kanban View will be exported to List View",
	},
	enterprise: {
		"user-not-found":
			"This email isn't set up for Gramax Enterprise Server. You can continue using the full features of the free version or contact your admin for further assistance.",
		"workspace-exit-warning-1": "Space will be closed for the current session.",
		"workspace-exit-warning-2": "Catalogs will be saved and will be available again after login.",
		"workspace-exit": "Sign out of space",
		"config-error": "Configuration issues. Contact your administrator.",
		"workspace-exists": "Space with this name already exists. You can go to this space or set a different name",
		"workspace-exists-title": "Already exists",
		"token-exchange-failed": "Failed to get a token using the one-time code.",
		"init-repo": {
			error: "Error creating repository",
			forbidden: "Insufficient permissions to create repository",
			"already-exists": "Repository with this name already exists",
		},
		"add-reviews": {
			forbidden: "Insufficient permissions to add reviewers",
			"not-found": "Failed to find resource",
			"failed-to-add-title": "Failed to add reviewers",
			"failed-to-add-message": "Contact your administrator to add reviewers manually.",
		},
		"edit-workspace": {
			"cant-edit": "Only the owner of the enterprise space can edit it",
			"error-get-edit-info": "Failed to get information about the enterprise space",
		},
		logout: {
			error: "Connection error",
			"error-message":
				"Could not logout. No connection to the server <code>{url}</code>.<p>Check your network connection and try again.</p>",
		},
		admin: {
			"settings-title": "Space settings",
			"hide-sidebar": "Hide sidebar",
			"show-sidebar": "Show sidebar",
			accesses: "Accesses",
			"adding-accesses": "Add accesses",
			mixed: "Mixed",
			selected: "Selected",
			saving: "Saving...",
			"search-error": "Search error",
			cancel: "Cancel",
			all: "All",
			unavailable: "Unavailable",
			tests: "Tests",
			result: "Result",
			passed: "Passed",
			failed: "Failed",
			search: "Search...",
			"edit-all-hint": "Select at least 2",
			"loading-more": "Loading more...",
			"not-available-in-bulk": "Not available when bulk editing",
			retry: "Retry",
			coverage: {
				title: "Coverage",
				"add-to-all": "Apply to all",
				"included-in": "Present in:",
			},
			forbidden: {
				title: "Access denied",
				description: "You do not have access to this page",
			},
			errors: {
				"operation-error": "Operation error",
				"loading-settings": "A problem occurred while loading the settings",
				"database-unavailable": "The database service is unavailable",
				"save-error": "Failed to save changes",
				"email-required": "Specify an email",
				"email-invalid": "Invalid email format",
				"no-connection": "No connection",
				causes: {
					offline: "Connection error",
					unknown: "Something went wrong",
				},
				descriptions: {
					offline:
						"No connection to the server <code>{url}</code>.<p>Check your network connection and try again.</p>",
					unknown: "Refresh the page and try again.",
				},
			},
			logout: {
				error: "Failed to end session. Status:",
			},
			pages: {
				plugins: "Modules",
				pluginDetail: "Module Details",
				check: "Style guide",
				workspace: "Space",
				groups: "User groups",
				editors: "Editors",
				members: "Members",
				users: "Users",
				resources: "Repositories",
				mail: "Mail server",
				guests: "External readers",
				quiz: "Training",
				modules: "Modules",
				metrics: "Metrics",
				viewMetrics: "Browsing history",
				searchMetrics: "Search queries",
				accessTokens: "Access tokens",
				license: "License",
			},
			license: {
				status: "Status",
				active: "License is active",
				invalid: "License is invalid",
				"expiration-date": "Valid until",
				"editor-limit": "Available editor licenses",
				"occupied-editors": "Licenses in use",
				unlimited: "Unlimited",
				perpetual: "Perpetual",
				"not-specified": "Not specified",
			},
			users: {
				user: "User",
				users: "Users",
				editor: "Editor",
				editors: "Editors",
				"editor-slots-full": "No free licenses",
				"editor-slots-used": "used",
				"users-not-found": "Users not found",
				add: "Add user",
				adding: "Add user",
				editing: "Edit user",
				"editing-many": "Edit users",
				"adding-many": "Add users",
				"editor-hint": "Allows the user to log into the Gramax editing application. Uses a license.",
				"user-only-role-hint": "This role can only be granted to users",
				"owner-requires-editor-hint": "Requires the Editor license",
				find: "Search by email or name...",
				"find-by-email": "Search by email...",
				"email-placeholder": "Enter email",
				"use-search-for-sso": "The list shows users with configured roles. Use search to configure new users.",
				errors: {
					"needs-access": "A user must be an editor, or have at least one access or group.",
					exists: "A user with this email already exists.",
				},
			},
			roles: {
				role: "Role",
				select: "Select role",
				workspaceOwner: "Space owner",
				catalogOwner: "Catalog owner",
				editor: "Editor",
				reviewer: "Reviewer",
				reader: "Reader",
				allowed: "Allowed",
				denied: "Denied",
				change: "Change role",
				editors: "Editors",
				workspaceOwners: "Workspace owners",
			},
			quiz: {
				"test-info": {
					"correct-answers-count": "Correct answers count",
					"answers-count": "Answers count",
				},
				switch: {
					on: "The training module is enabled",
					off: "The training module is disabled",
				},
				filters: {
					users: {
						search: "Search users...",
						loading: "Loading users...",
					},
					tests: {
						search: "Search tests...",
						loading: "Loading tests...",
						empty: "Tests not found",
					},
				},
				"users-test-table": {
					test: "Test name",
					result: {
						free: "The test has no correct answers",
						tooltip: "Number of correct answers: {countOfCorrectAnswers} out of {countQuestions}",
					},
					"created-at": "Completed at",
				},
			},
			resources: {
				"repository-permission": "Configure permissions",
				add: "Add repository",
				adding: "Add repository",
				editing: "Edit repository",
				"editing-many": "Edit repositories",
				"select-repository-description": "Select repository from Git storage",
				"select-repository-placeholder": "Select repository",
				"repository-not-found": "Repository not found",
				"main-branch": "Main branch",
				"main-branch-protection": "Publishing protection",
				"main-branch-protection-description":
					"Publication in the main branch in the Gramax interface is prohibited. Changes can be made through merging.",
				"select-main-branch-placeholder": "Select main branch",
				"protected-branch-not-found": "Branches not found",
				"adding-user-accesses": "Add accesses to users",
				"adding-group-accesses": "Add accesses to groups",
				"adding-guest-accesses": "Add accessees to guests",
				find: "Search by name...",
				groups: {
					"not-found": "Groups not found",
				},
				branches: {
					placeholder: "Select branches",
					required: "Select at least 1 branch",
				},
				catalog: {
					permission: {
						description: "Configure permissions to the catalog",
					},
				},
				errors: {
					"base-not-deletable": "Base repositories cannot be deleted",
				},
			},
			groups: {
				group: "Group",
				groups: "Groups",
				add: "Add group",
				adding: "Add group",
				editing: "Edit group",
				"adding-many": "Add groups",
				"editing-many": "Edit groups",
				find: "Search by name...",
				"name-placeholder": "Enter name",
				"use-search-for-sso":
					"The list shows custom groups and SSO groups with configured roles. Use search to configure new SSO groups.",
				"sso-reader-only-hint": "SSO groups can only be assigned the Reader role",
				badges: {
					sso: "SSO",
					system: "System",
				},
				errors: {
					"delete-disabled": "System and SSO groups cannot be deleted",
					"name-required": "Specify a name",
					exists: "A group with this name already exists",
				},
			},
			guests: {
				guest: "External reader",
				guests: "External readers",
				reader: "Reader",
				readers: "Readers",
				add: "Add external reader",
				adding: "Add external reader",
				editing: "Edit external reader",
				"editing-many": "Edit external readers",
				"reader-only-hint": "External readers can only be assigned the Reader role",
				"find-readers": "Search by email...",
				"email-placeholder": "Enter email",
				"otp-enabled": "OTP Login",
				"otp-description": "One-time password login via email for external readers to the documentation portal",
				"general-settings": "General settings",
				"session-duration-hours": "Session duration (hours)",
				"whitelist-settings": "Whitelist settings",
				"whitelist-enabled": "Use whitelist",
				"whitelist-domains": "Whitelist domains",
				"whitelist-domains-description":
					"Specify email address domains allowed for external user login (e.g., example.com, company.org)",
				domains: {
					title: "Domain",
					find: "Find...",
					"add-domain": "Add domain",
					"add-domain-hint": "Enter a domain to add to the allow list",
				},
				errors: {
					"domain-required": "Enter domain",
					"domain-invalid": "Invalid domain",
					"domain-exists": "Domain already exists in the list",
					"needs-access": "An external reader must have at least one access.",
					"domain-not-allowed": "This email domain is not on the whitelist.",
				},
			},
			mail: {
				"sender-settings": "Sender settings",
				"sender-address": "Sender address (From)",
				"smtp-settings": "SMTP settings",
				host: "Host",
				port: "Port",
				password: "Password",
				"password-placeholder": "Enter password",
			},
			workspace: {
				"workspace-name": "Space name",
				"main-info": "Main information",
				"source-url": "Source URL (GitLab)",
				"source-type": "Source type",
				templates: {
					title: "Templates",
					description:
						"Upload templates in supported formats here. When exporting an article from Gramax, you can choose one of them to automatically format the document in your corporate style.",
					word: {
						title: "Word templates",
						description: "Supported formats: .docx, .docm, .dotx, .dotm.",
					},
					pdf: {
						title: "PDF templates",
						description: "Supported format: .css.",
					},
				},
				views: {
					folder: "Folder",
					section: "Section",
				},
				sections: {
					title: "Catalog sections",
					add: "Add section",
					empty: "Catalog sections not created",
					"empty-hint": 'Click "Add section" to create the first section',
					"key-exists": 'Section with key "{key}" already exists. Please choose another key.',
					"table-header": "Catalog name",
					dialog: {
						"edit-title": "Edit section",
						key: "Key",
						"key-placeholder": "Enter key",
						"name-placeholder": "Enter name",
						"icon-description":
							"Enter the Lucide icon name in kebab-case (e.g. folder-open, settings, user-check)",
						view: "View",
						"view-empty": "No views found",
						"view-placeholder": "Select display",
						"description-placeholder": "Enter section description",
						catalogs: "Catalogs",
						"catalogs-description": "Add catalogs and arrange their order in the section",
						ok: "Ok",
						"unsaved-title": "You have unsaved changes",
						"unsaved-description":
							"You made changes to the section but did not apply them. Applying changes does not save the configuration.",
						back: "Back",
						"close-without-applying": "Close without applying",
						apply: "Apply changes",
						find: "Search by name...",
					},
					"add-catalogs": {
						title: "Select catalogs",
						empty: "No catalogs found",
						loading: "Searching catalogs...",
						description: "Select catalogs to add to the list",
					},
				},
				repositories: {
					title: "Base repositories",
					add: {
						title: "Select repositories",
						empty: "No repositories found",
						description: "Select repositories to add",
						label: "Repositories",
					},
				},
			},
			check: {
				"service-unavailable": "The style guide service is unavailable",
				"check-failed": "Failed to check the article",
				"checking-article": "Checking article",
				"import-rules": "Import rules",
				"export-rules": "Export rules",
				"run-all-tests": "Run all tests",
				"stop-all-tests": "Stop tests",
				"rules-llm-title": "LLM-rules",
				"rules-lgt-title": "LanguageTool-rules",
				"rules-types": {
					plainText: "Only for a plain text",
					heading: "Only for headings",
				},
				"rule-title": "Rule settings",
				"rule-name-placeholder": "Rule name",
				"rule-new-name": "New rule",
				"rule-llm-prompt-placeholder": "LLM prompt description...",
				"rule-types-placeholder": "Chose types for a rule...",
				"tests-correct": "Tests passed",
				"tests-title": "Test Section",
				"tests-correct-section-title": "Examples with mistakes",
				"tests-incorrect-section-title": "Examples without mistakes",
				"test-add": "Add test",
				"test-delete-confirm": "Are you sure, that you want to delete this test?",
				"test-run": "Run test",
				"test-placeholder": "Example's text...",
				"test-popup-title": "Last test",
				"test-popup-empty": "There will be results of the last test",
				"test-popup-done": "Done",
				"service-connection-error":
					"There was a problem connecting to the service, please contact technical support",
				retry: "Try again",
				"save-error": "Error saving settings",
				"rule-name-duplicate": "A rule with this name already exists",
				"rule-name-xml-hint": 'Can only be edited in the "Description" field in the "name" attribute',
				"passed-tooltip": "{passed} of {total} passed successfully",
			},
			plugins: {
				find: "Search by name...",
			},
			"access-tokens": {
				"service-unavailable": "The access tokens service is unavailable",
			},
		},
	},
	"enterprise-cloud": {
		buttons: {
			publish: "Publish",
		},
		"org-settings": {
			title: "Organization settings",
			"cant-edit": "Only the organization owner or admin can edit the organization settings",
			users: {
				email: "Email",
				placeholder: "Find users",
				invite: "Invite",
				"email-placeholder": "john.doe@gmail.com",
				"invite-title": "Invite user",
				"status-header": "Status",
				status: {
					user: "Active",
					invite: "Invited",
				},
				"invite-form": {
					title: "Invite user",
					description: "Enter the email of the user you want to invite",
				},
				admin: {
					"admin-hint": "Gives the user access to organization settings",
					"owner-cant-be-admin-hint": "Can't set owner as admin",
					"cant-set-invite-as-admin-hint": "Only active users can be made admins",
				},
				roles: {
					admin: "Admin",
					owner: "Owner",
				},
			},
			subscription: {
				"choose-title": "Choose a plan",
				"required-description": "You've run out of free seats. Choose a plan to add new members.",
				"monthly-title": "Monthly subscription",
				"annual-title": "Annual subscription",
				"per-month": "/ mo",
				"per-editor": "per editor",
				total: "Total",
				"seats-count": "editor(s)",
				"billed-yearly": "Billed yearly",
				continue: "Continue",
				"current-plan": "Current plan",
				"load-error": "Failed to load tariffs",
				payment: {
					title: "Confirm changes",
					"change-period-title": "Switch to annual plan",
					seats: "editor seats",
					"set-seats-count": "Number of seats in the organization",
					"set-seats-count-placeholder": "Enter the number of seats",
					"not-enough-seats-error": "Enter at least {minSeatsCount} editor seats to continue.",
					"per-editor-yearly": "Price per editor / year",
					"total-monthly": "New monthly total",
					"total-yearly": "New yearly total",
					"due-today-title": "Total due today",
					"due-now-seats": "Added seats (pro-rated)",
					"due-today": "Total due today",
					terms: "I agree to the terms of service",
					pay: "Pay",
					"pay-and-enable-autorenew": "Pay and enable auto-renewal",
					"autorenew-notice":
						"The subscription renews automatically. The amount depends on the number of members. Auto-renewal can be disabled.",
					"payment-method-save-notice": "The payment method will be saved for future payments.",
					"offer-acceptance-prefix": "By clicking the button, you accept the",
					offer: "offer",
					"pay-by-card": "Pay by bank card",
					"create-invoice": "Create invoice",
					"load-error": "Failed to load payment details",
					"payment-methods-load-error": "Failed to check payment methods",
					"pay-error": "Failed to process payment",
					"unused-days-credit": "Unused days credit",
					"recover-title": "Resume subscription",
					"reset-to-free-message": "The subscription will be switched to the free plan.",
					"recover-confirm": "Switch to the free plan",
				},
				"payer-type": {
					title: "How should the subscription be issued?",
					description: "The organization has no saved payment methods yet. Choose the payer type.",
					individual: "Individual",
					"individual-description": "Continue with card payment and save it as a payment method.",
					"legal-entity": "Legal entity",
					"legal-entity-description":
						"Fill in organization requisites, then continue to payment confirmation.",
					"legal-entity-title": "Issue subscription to a legal entity",
					"legal-entity-submit": "Issue",
				},
			},
			billing: {
				title: "Billing",
				"change-plan": "Change plan",
				"your-plan": "Your plan",
				"current-plan": "Current plan",
				type: {
					name: "Type",
					individual: "Individual",
					corporate: "Corporate",
				},
				"plan-free": "Free",
				"plan-paid": "Paid",
				"period-month": "Monthly",
				"period-year": "Annual",
				"available-seats": "Available seats",
				"next-charge-date": "Next charge date",
				"next-charge-amount": "Next charge amount",
				"will-become-free-tooltip":
					"The next payment will be 0, because the organization has fewer occupied seats than {freeSeatsLimit}",
				"load-error": "Failed to load billing information",
				"legal-entity": {
					title: "Switch to legal entity billing",
					"search-error": "Failed to load requisites",
					"submit-error": "Failed to switch to legal entity billing",
					submit: "Switch",
					type: "Type",
					company: "Legal entity",
					"individual-entrepreneur": "Individual entrepreneur",
					"full-name": "Full name",
					inn: "Tax ID",
					kpp: "KPP",
					"registered-address": "Address",
					"document-email": "Document email",
					"reqs-select": {
						title: "Select legal entity",
						placeholder: "Find legal entity",
					},
					"email-input": {
						title: "Enter legal entity's email",
						placeholder: "john.doe@gmail.com",
					},
				},
				"cancel-subscription": {
					open: "Cancel subscription",
					title: "Cancel subscription",
					description:
						"The subscription will stay active until <b>{{currentPeriodEnd}}</b>. All paid seats will remain active until this date, and there will be no further charges. After that, the organization will be switched to the free plan, which offers up to <b>{{freeSeatsLimit}}</b> free seats.",
					"seats-overflow-warning":
						"Currently, the organization has <b>{{occupiedSeats}}</b> members, but the free plan allows for <b>{{freeSeatsLimit}}</b> seats. After <b>{{currentPeriodEnd}}</b>, only the first <b>{{freeSeatsLimit}}</b> members will be able to work with catalogs. The rest will remain in the organization but won't be able to read or make changes until you renew your subscription.",
					"payment-method-notice":
						"Saved payment methods won't be deleted. You can delete them separately in the payment method section.",
					close: "Keep subscription",
					action: "Cancel subscription",
					error: "Failed to cancel subscription",
				},
				payments: {
					title: "Payment history",
					date: "Date",
					kind: "Type",
					amount: "Amount",
					status: "Status",
					empty: "No payments yet",
					kinds: {
						seat_purchase: "Seat purchase",
						subscription_renewal: "Subscription renewal",
						subscription_recovery: "Subscription recovery",
						ai_wallet_topup: "AI balance top-up",
						plan_upgrade: "Plan upgrade",
					},
					statuses: {
						pending: "Pending",
						succeeded: "Succeeded",
						canceled: "Canceled",
					},
				},
			},
			"payment-methods": {
				title: "Payment methods",
				add: "Add",
				"set-default": "Make default",
				delete: "Delete",
				card: "Card",
				expiry: "Expiry",
				type: "Type",
				default: "Default",
				"bind-error": "Failed to start card binding",
				"bind-failed": "Card was not bound",
				"bind-pending": "Verifying card binding…",
				"set-default-error": "Failed to set the default payment method",
				"delete-error": "Failed to delete the payment method",
				"make-another-default": {
					title: "Make another payment method default",
					description: "You must select new payment method as default before deleting the old one",
				},
			},
			"ai-wallet": {
				title: "AI credits",
				balance: "Current balance",
				"top-up": "Top up",
				"load-error": "Failed to load the AI wallet balance",
				modal: {
					title: "Top up AI wallet",
					"amount-label": "Top-up amount",
					"amount-placeholder": "Enter amount",
					"amount-invalid": "Enter an amount not less than {minAmount}",
					pay: "Top up",
					"payment-method-save-notice": "The payment method will be saved for future payments.",
					"offer-acceptance-prefix": "By clicking the button, you accept the",
					offer: "offer",
					"pay-error": "Failed to process the top-up",
					"form-error": "Impossible to send form",
				},
			},
			documents: {
				title: "Invoices",
				date: "Date",
				number: "Number",
				download: "Download as PDF",
				error: "Could not load invoices list",
			},
			pages: {
				organization: "Organization",
				resources: "Resources",
				users: "Users",
				billing: "Billing",
				"payment-methods": "Payment methods",
				"ai-wallet": "AI credits",
				"access-tokens": "Access tokens",
				documents: "Documents",
				repos: "Repositories",
			},
			organization: {
				save: "Save",
				name: {
					label: "Organization name",
					placeholder: "Enter organization name",
				},
			},
			tokens: {
				name: "Name",
				"name-placeholder": "Enter token name",
				"created-at": "Created at",
				"expires-at": "Expires at",
				"expires-at-placeholder": "Pick a date",
				placeholder: "Find tokens",
				create: "Create token",
				"create-form": {
					title: "Create token",
					description: "Fill in the fields to create a new token",
				},
				"show-form": {
					title: "Token created",
					description: "Copy the token now — it won't be available later",
					"copy-placeholder": "Copy token",
				},
			},
		},
		organization: {
			loading: "Loading organizations...",
			"error-loading": "Failed to load organizations",
		},
		"invite-mismatch": {
			title: "Email Address Mismatch",
			message:
				"The organization invitation was sent to a different email address. Please make sure you're using the correct account.",
		},
		"sign-out": {
			title: "Sign out",
			description: "Are you sure you want to sign out?",
		},
		forms: {
			"publish-new-catalog": {
				name: "Publish catalog",
				description: "Set the catalog and repository names",
				message:
					"We’ll store this catalog in the <code>{{repositoryName}}</code> repository. The repository name will be used in the catalog URL and can’t be changed after publishing.",
			},
		},
		"subscription-inactive-alert": {
			title: {
				past_due: "Subscription past due",
				suspended: "Subscription suspended",
			},
			description: {
				past_due: "Subscription past due. Please pay the subscription to continue using the service.",
				suspended: "Subscription suspended. Please pay the subscription to resume the subscription.",
			},
			buttons: {
				pay: "Pay",
			},
		},
	},
	network: {
		error: {
			title: "Unable to connect to the server",
			body: "Check your internet connection and try again. If the problem persists, the server may be temporarily unavailable.",
		},
	},
	"experimental-features": {
		label: "Experimental Features",
		status: {
			"in-dev": "This feature is under development and not intended to be used",
			experimental: "This feature is experimental and may not work as expected",
			unstable: "This feature is unstable and likely contains bugs",
			beta: "This feature is not yet fully stabilized and still may contain bugs",
		},
	},
	notifications: {
		title: "Notifications",
		"mark-all-as-read": "Mark all as read",
		loading: "Loading...",
		error: "Failed to load notifications",
		"no-notifications": "No notifications",
		"loading-more": "Loading more...",
		"mailing-list": "Mailing list",
		"mailing-list-description": "Manage your mailing list subscriptions.",
		"mailing-list-groups": "Groups",
		"mailing-list-users": "Users",
		"mailing-list-select-groups": "Select groups...",
		"mailing-list-search-users": "Search users...",
		settings: "Edit notifications",
		"settings-description": "Select when you want to receive notifications for this article.",
		"on-create": "Notify on creation",
		"on-change": "Notify on change",
		"on-both": "Notify on creation or change",
		disabled: "Do not notify",
	},
	export: {
		name: "Export",
		zip: {
			catalog: "Catalog to ZIP",
			article: "Article to ZIP",
			category: "Section to ZIP",
			process: "Preparing to export ZIP archive",
		},
		docx: {
			catalog: "Catalog to DOCX",
			article: "Article to DOCX",
			category: "Section to DOCX",
			process: "Preparing to export DOCX document",
		},
		pdf: {
			catalog: "Catalog to PDF",
			article: "Article to PDF",
			category: "Section to PDF",
			process: "Exporting PDF",
			canceled: "Cancelling...",
			tocPageTitle: "Contents",

			form: {
				title: {
					catalog: "Export catalog to PDF",
					category: "Export section to PDF",
					article: "Export article to PDF",
				},
				description: "Customize content and formatting.",
				titlePage: "Title page",
				titlePageDescription: "Add a title page with the catalog/section name and basic information.",
				tocPage: "Table of contents",
				tocPageDescription:
					"Add a section with a table of contents, where the catalog sections and page numbers will be listed.",
				titleNumber: "Section numbering",
				titleNumberDescription: "Automatic numbering of article titles",
				template: "Custom template",
				templateDescription: {
					body: "Use custom CSS styles to format the PDF.",
					more: "More",
				},
				sectionTitle: "Document content and formatting",
				openPrint: "Open print dialog",
				printDialog: 'In the print dialog select "Save as PDF"',
				footerDescription:
					"After exporting, the browser’s print dialog will open.\nSelect A4, and in the “Printer/Destination” field choose Save as PDF.",
			},

			error: {
				title: "Error exporting to PDF",
				message: "Something went wrong during the export to PDF",
			},
		},
	},
	account: "Account",
	add: "Add",
	apply: "Apply",
	article2: "Article",
	article3: "article",
	article4: "articles",
	branch: "Branch",
	branches: "Branches",
	cancel: "Cancel",
	category2: "section",
	category3: "section",
	checking: "Checking",
	close: "Close",
	collapse: "Collapse",
	command: "Command",
	comment: "Comment",
	"no-selected": "No selected",
	"pick-random-value": "Pick random value",
	"comment-on": "Comment",
	company: "Internal documentation",
	configure: "Configure",
	confirm: "Confirm",
	continue: "Continue",
	copied: "Copied",
	copy: "Copy",
	count: "count",
	creating: "Creating",
	current: "English",
	delete: "Delete",
	deleting: "Deleting",
	description: "Description",
	edit2: "Edit",
	actions: "Actions",
	edit: "Edit",
	editing: "Editing",
	element: "Element",
	"enter-value": "Enter value",
	error: "Error",
	existing: "existing",
	exit: "Exit",
	expand: "Expand",
	field: "Field",
	file: "File",
	find: "Search",
	find2: "Find",
	multiSelect: {
		placeholder: "Select value",
		search: "Find",
		loading: "Loading...",
		error: "Failed to load options",
		inputHint: "Type to search",
		empty: "No results found",
	},
	replace: "Replace",
	replaceAll: "Replace all",
	caseSensitive: "Case sensitive",
	wholeWord: "Whole word",
	filter: "Filter",
	fn: "Functional blocks",
	formula: "Formulas",
	group2: "groups",
	group: "Group",
	healthcheck: "Error check",
	"healthcheck-description": "Check for errors in the catalog",
	"check-errors": "Check for errors",
	hide: "Hide",
	icon: "Icon",
	image: "Image",
	in: "in",
	interface: "Interface",
	invalid2: "Invalid",
	invalid: "Invalid",
	link2: "Link",
	link: "Link",
	clickToViewDetails: "Click to view details",
	load: "Load",
	loading2: "Loading...",
	loading: "Loading...",
	loadWait: "Waiting for download",
	local: "Local branch",
	mail: "Email",
	email: "Email",
	more: "More",
	"read-more": "Read more..",
	name: "Name",
	name2: "Name",
	"enterprise-catalog-required-title": "Catalog available in GES",
	"enterprise-catalog-required-description":
		"This catalog is only available in Gramax Enterprise Server (GES). Open the link in your organization's GES.",
	ok: "Okay",
	open: "Open",
	"open-in-new-window": "Open in new window",
	other: "Other",
	page: "Page",
	products: "Products and services",
	projects: "Projects",
	pull: "Pull",
	refresh: "Refresh",
	remote: "Published",
	repository2: "repository",
	repository: "Repository",
	resolve: " Resolved ",
	save: "Save",
	save2: "Saving",
	see: "See",
	select: "Select",
	send: "Send",
	signature: "Caption",
	fragment: "Fragment",
	"fragment-link": "Fragment link",
	source2: "Source",
	source: "Source",
	space: "Section",
	storage2: "storage",
	storage: "Storage",
	strike: "Strikethrough",
	style: "Style",
	switch: "Switch",
	sync: "Synchronize",
	synchronization: "Synchronizing...",
	theme: {
		title: "Theme",
		light: "Light",
		dark: "Dark",
	},
	title: "Title",
	token: "token",
	type: "Type",
	unresolve: "Unresolved",
	user: "User",
	value: "value",
	values: "pcs",
	"export-logs": {
		title: "Export logs",
		session: "Current session",
		today: "Today",
		"last-7-days": "Last 7 days",
		all: "All",
	},
	"log-level": {
		title: "Log level",
		description: "Higher levels help support investigate issues but make log files larger",
		off: "Off",
		commands: "Commands",
		important: "Important",
		internal: "Internal logic",
		files: "File interaction",
		full: "Full",
		desc: {
			off: "No logs are written",
			commands: "Command execution, init and high-level actions",
			important: "Key steps inside commands: publish, autopull, connections",
			internal: "Internal work of Git, catalog and file structure",
			files: "Plus write operations of file interaction",
			full: "Everything, including reads",
		},
	},
	version: "Version",
	warning: "Warning",
	who: "Who",
	forward: "Forward",
	backward: "Backward",
	"add-account": "Add account",
	"add-annotation": "Add annotation",
	"add-new-branch": "Add new branch",
	"add-new-fragment": "Add new fragment",
	"add-new-source": "Add new source",
	"add-new-storage": "Add new storage",
	"add-square": "Add square",
	"add-storage": "Add storage",
	"storage-actions": "Storage actions",
	"add-to-continue-downloading": "Add it to continue downloading.",
	"add-value": "Add value",
	"after-merge": "After merging",
	"all-groups": "All groups",
	"and-sync-catalog": "And synchronize changes?",
	"annotation-text": "Annotation text",
	"article-titles": "Article titles",
	"authorization-by-mail": "Authorization by email",
	"bottom-left-pointer": "Bottom left annotation",
	"bottom-right-pointer": "Bottom right annotation",
	"branch-name-already-exists": "A branch with this name already exists",
	"branch-name-can-not-be-reserved-names": "Branch name cannot match reserved names HEAD",
	"branch-name-can-not-have-dot-and-slash-at-end-and-contain-sequences-of-slashes":
		"Branch name cannot end with '/' or '.', and contain sequences of '//' ",
	"branch-name-can-not-have-dots-sequence-and-leading-dot":
		"Branch name cannot start with a dot or contain a sequence of double dots '..'",
	"branch-name-can-not-have-encoding-symbols":
		'Branch name cannot contain special characters such as space, *, ?, [], ~, :, ", <, >, |, ^, \\',
	"branch-name-can-not-have-existing-prefix-branch": "Branch name cannot contain a prefix like an existing branch",
	"branch-name-not-end-with-lock": "Branch name cannot end with '.lock'",
	"branches-are-updated": "Branches updated",
	"by-azure": "By Azure",
	"by-mail": "By email",
	"cancel-crop": "Cancel crop",
	"space-name-min-length": "The space name must contain at least 2 characters",
	"repository-name-min-length": "The repository name must contain at least 2 characters",
	"directory-name-min-length": "The directory name must contain at least 2 characters",
	"cant-be-same-name": "The name must be unique",
	"cant-be-same-path": "The path must be unique",
	"cant-edit-this-line": "Cannot edit this line",
	"cant-get-fragment-data": "Check if the path is correct and if the fragment file is in the repository",
	"catalog-icons-title": "Catalog icons",
	"icon-picker": {
		search: {
			icons: "Search icon",
			emoji: "Search emoji",
		},
		tabs: {
			icons: "Icons",
			emoji: "Emoji",
			"file-input": "Upload",
		},
		categories: {
			"catalog-icons-title": "Catalog icons",
			"recently-used-icons": "Recently used",
			text: "Text",
			accessibility: "Accessibility",
			medical: "Medical",
			home: "Home",
			multimedia: "Multimedia",
			devices: "Devices",
			photography: "Photography",
			layout: "Layout",
			"food-beverage": "Food & Beverage",
			transportation: "Transportation",
			emoji: "Emoji",
			buildings: "Buildings",
			files: "Files",
			arrows: "Arrows",
			science: "Science",
			account: "Account",
			tools: "Tools",
			design: "Design",
			gaming: "Gaming",
			shopping: "Shopping",
			social: "Social",
			finance: "Finance",
			travel: "Travel",
			connectivity: "Connectivity",
			notifications: "Notifications",
			navigation: "Navigation",
			animals: "Animals",
			development: "Development",
			security: "Security",
			shapes: "Shapes",
			weather: "Weather",
			math: "Math",
			time: "Time",
			nature: "Nature",
			charts: "Charts",
			communication: "Communication",
			mail: "Mail",
			cursors: "Cursors",
			sports: "Sports",
			sustainability: "Sustainability",
		},
		"emoji-categories": {
			"recently-used": "Recently used",
			"smileys-emotion": "Faces",
			"people-body": "People & Body",
			"animals-nature": "Animals & Nature",
			"food-drink": "Food & Drink",
			"travel-places": "Travel & Places",
			activities: "Activities",
			objects: "Objects",
			symbols: "Symbols",
			flags: "Flags",
		},
	},
	"change-and-sync": "Change and synchronize",
	"check-diagrams": "Diagrams",
	"edit-diagram": "Edit diagram",
	"edit-diagram-description": "Edit the diagram content",
	"check-file-path": "Check if the file path is correct",
	"check-fs": "File Structure",
	"check-icons": "Icons",
	"check-images": "Images",
	"check-links": "Links",
	"check-unsupported": "Unsupported elements",
	"check-content": "Articles",
	"check-comments": "Comments",
	"check-aliases": "Additional paths",
	"choose-header": "Choose header",
	"clarifying-tags": "Clarifying tags",
	"click-to-copy": "Click to copy",
	"clone-branch-not-found":
		"This can happen in two cases: the branch was deleted or created but not published. Request a new link.",
	"clone-error-desc1": "Check if the repository exists",
	"clone-error-desc2": "Also, make sure you have the rights to edit it.",
	"clone-fail": "Failed to load catalog",
	"close-comment": "Close comment",
	"exit-edit-mode": "Are you sure you want to exit edit mode?",
	"comments-to-article": "Comment to article",
	"commit-message": "Comment",
	"confirm-answer-delete": "Delete comment?",
	"confirm-comment-delete": "Delete the entire discussion thread?",
	"confirm-create-catalog-on-clone":
		"Gramax will create a docs folder in the repository and add system catalog files to it. Then you can start working.",
	"confirm-create-catalog-on-clone-header": "No catalog in the repository. Create?",
	"connect-storage": "Connect storage",
	"connect-storage-to-leave-comment": "Connect storage to leave a comment",
	"continue-locally": "Continue locally",
	"create-branch": "Create branch",
	"create-files-to-edit-markdown": "Add an article to edit",
	"create-new2": "Create catalog",
	"created-in-gramax": "Created in Gramax",
	"crop-image": "Crop image",
	"current-branch": "Displayed branch",
	"current-version": "Current version",
	"danger-text": "Error",
	"delete-as-resolved": "Delete as resolved",
	"delete-branch": "Delete branch",
	"delete-file": "Delete file",
	"delete-fragment-confirm": "Are you sure you want to delete the fragment?",
	"delete-fragment-confirm-not-use": "This fragment is not used in any articles",
	"delete-fragment-desc": "You are about to delete a fragment that is currently used in the following articles:",
	"delete-fragment-warn":
		"After deleting the fragment, articles where it was used will display errors instead of the removed fragment",
	"deleting-fragment-in-use": "Deleting fragment in use",
	"desktop-settings.target-directory-description": "Folder on the local disk where catalogs for editing are located",
	"display-on-homepage": "Display on homepage",
	"dont-save": "Don't save",
	"edit-on": "Edit in",
	"empty-field": "Empty field",
	"enter-branch-name": "Enter branch name",
	"enter-fragment-text": "Enter fragment text",
	"error-expand": "Show details",
	"error-mail": "The email provided is incorrect.",
	"error-sing-in": "Sign in error",
	"error-occured": "An error occurred while displaying the documentation.",
	"export-disabled": "Add an article to export",
	"file-content": "File content",
	"file-download-error-message": "It may have been moved or deleted.",
	"file-download-error-title": "Failed to download file",
	"find-branch": "Search branch",
	"for-certain-users": "For certain users",
	"foreign-key": "Foreign key FK",
	"generate-link": "Generate link",
	"git-pull": "Git pull",
	"git-status": "Git status",
	"go-to-article": "Go to article",
	"go-to": "Go to",
	"img-h": "Vertical image groups",
	"img-v": "Horizontal image groups",
	"in-article": "In the article",
	"in-branch": "To branch",
	"incorrects-icons": "Incorrect icons",
	"incorrects-paths": "Incorrect paths",
	"incorrects-unsupported": "Elements",
	"incorrects-content": "Incorrect syntax",
	"incorrects-comments": "Unassigned comments",
	"incorrects-aliases": "Conflicting paths",
	"alias-taken": "This path is already in use or matches an existing article path",
	"alias-self": "Matches the article's own path — the path does nothing",
	"alias-shadowed": "An article already exists at this path — the path will never work",
	"alias-duplicate": "Taken by {{winner}} — the path will not work here",
	"alias-broken-moved": "Invalid moved date: {{moved}}",
	"markdown-error": "Incorrect markdown",
	"info-text": "Information",
	"init-git-version-control": "Initialize Git",
	"invalid-index": "Index does not meet the requirements!",
	"invalid-credentials-title": "Failed to connect",
	"invalid-credentials-text": "Please check the accuracy of the entered information.",
	"lab-text": "Note",
	"leads-to-the-branch": "You are following a link that leads to a different branch.",
	"leave-comment": "Leave a comment",
	"leave-file": "Keep file",
	"link-end-date": "Specify link expiration date",
	"mail-or-group": "Email or Group",
	"max-length": "Max characters: ",
	"must-be-not-empty": "This field cannot be empty.",
	"no-access-to-storage": "No access to storage",
	"no-branch-found": "No branches found",
	"no-encoding-symbols-in-url": "URL can only contain Latin letters, numbers, and the symbols '-', '_', '.'",
	"no-encoding-symbols-in-url-no-dot": "URL can only contain Latin letters, numbers, and the symbols '-', '_'",
	"no-headers": "(No headers)",
	"no-schemas-block": "Do not display “Schemas” block",
	"no-such-function": "No such function!",
	"not-found": "Not found",
	"not-found2": "Not found",
	"note-text": "Warning",
	"numbero-of-unsolved-comments": "Number of unresolved comments",
	"on-the-same-version": "Is on the same version as this branch",
	"open-api": "OpenAPI",
	"hide-openapi-info": "Hide API title and description",
	"show-openapi-info": "Show API title and description",
	OpenApi: "OpenAPI",
	Html: "HTML",
	"Img-v": "Vertical group of images",
	"Img-h": "Horizontal group of images",
	Formula: "Formula",
	Icon: "Icon",
	Fragment: "Fragment",
	View: "View",
	"other-version": "Other version",
	"publish-catalog": "Publish catalog",
	"publish-changes": "Publish changes",
	"quote-text": "Quote",
	"remove-link": "Remove link",
	"repository-https-url": "Repository HTTPS URL",
	"repository-ssh-url": "Repository SSH URL",
	"required-parameter": "Required parameter",
	"resolve-conflict": "Resolve conflict",
	"save-and-exit": "Save and exit",
	"save-article-in": "Save article in",
	"save-changes": "Save changes",
	"schemas-block": "Display “Schemas” block",
	"select-all": "Select all",
	"select-or-add-new": "Select or add new",
	"share-access-token-not-installed": "Share Access Token not installed",
	"show-comment": "Show comment",
	"show-comments": "Comments",
	"show-diffs": "Changes",
	"sing-in": "Sign in",
	"sing-out": "Sign out",
	"fragment-already-exists": "A fragment with this id already exists",
	"fragment-render-error": "Failed to render fragment",
	"so-far-its-empty": "It's empty so far",
	"storage-not-connected": "Storage not connected",
	"sync-offline": "Offline. Click to reconnect.",
	"sync-offline-toast-title": "No access to the server",
	"sync-offline-toast-desc": "Switching to offline mode.",
	"submit-login-link": "Send login link",
	"switch-branch": "Switch branch",
	"sync-catalog": "Synchronize changes?",
	"sync-catalog-push1": "unpublished change",
	"sync-catalog-push2": "unpublished changes",
	"sync-catalog-push3": "unpublished changes",
	"sync-catalog-changed1": "change available for synchronization",
	"sync-catalog-changed2": "changes available for synchronization",
	"sync-catalog-changed3": "changes available for synchronization",
	"sync-catalog-desc": "The catalog version is outdated. Synchronize to get changes.",
	"sync-logs": "Synchronize logs",
	"sync-something-changed": "Something has changed in the repository, but the catalog is still up-to-date",
	"system-icons-title": "System icons",
	"takes-to-more-current-version": "Leads to a more current catalog version",
	"technical-details": "Technical Details",
	"tip-text": "Tip",
	"to-branch": "To branch",
	"to-navigate": "Navigation",
	click: "Click",
	"to-make-changes": "to make changes",
	"today-at": "Today at ",
	"top-left-pointer": "Top left annotation",
	"top-right-pointer": "Top right annotation",
	"unable-to-get-sync-count": "Unable to retrieve changes",
	"unsaved-changes": "Save changes?",
	"unsupported-elements-title": "Unsupported elements",
	"unsupported-elements-warning1": "DOCX does not support some elements of Gramax.",
	"unsupported-elements-warning2": "List of articles with unsupported elements",
	"unsupported-elements-warning3": "The file will be saved without them.",
	"update-branches": "Update branches list",
	"users-group": "Which group to give permissions",
	"view-usage": "View usage",
	"working-directory": "Working directory",
	"yesterday-at": "Yesterday at ",
	"your-branch": "Your branch",
	"edit-html": "Edit HTML",
	"edit-html-description": "Edit the HTML content",
	"do-not-show-again": "Do not show again",
	properties: {
		name: "Properties",
		add: "Add property",
		all: "All",
		"no-properties": "No properties",
		empty: "(empty)",
		"already-exist": "This property already exists",
		find: "Find property",
		"delete-property-confirm":
			"Are you sure you want to delete this property? It will be removed from all articles.",
		"select-all": "(select all)",
		"validation-errors": {
			"all-parameters-added": "All parameters added",
			"prop-creator": "Property with this name already exists or name is too short",
			"no-groupby": "Select a field for grouping",
			"no-defs": "Select at least one field for filtering",
			"no-content": "For selected fields, there are no items in the catalog",
		},
		system: {
			hierarchy: {
				name: "Hierarchy",
				values: {
					"child-to-current": "Child to current article",
				},
			},
		},
		warning: {
			"delete-tag-from-catalog": {
				title: "Delete property from catalog",
				body: "Are you sure you want to delete this property? It will be removed from all articles.",
			},
			"delete-value-from-catalog": {
				title: "Delete value from property",
				body: "Are you sure you want to delete this value? It will be removed from all articles.",
			},
		},
		view: {
			name: "View",
			"group-by": "Group by",
			"order-by": "Order by",
			filter: "Filter",
			select: "Select",
			displays: {
				name: "View",
				list: "List",
				table: "Table",
				kanban: "Kanban",
			},
		},
		types: {
			Numeric: "Number",
			Flag: "Flag",
			Date: "Date",
			Enum: "One from the list",
			Many: "Several from the list",
			Text: "Text",
			Array: "Array",
			BlockMd: "Block of text",
			InlineMd: "Inline Markdown",
			News: "News",
		},
		options: {
			docportalVisible: {
				name: "Show to readers",
				description: "Property will be visible and searchable on a documentation portal",
			},
		},
		selected: "(selected)",
		article: "Article",
		archive: "Archive",
		"update-affected-articles": "articles will be affected",
		"add-property": "Add property",
		"no-values": "No values",
	},
	"create-new": "Create new",
	manage: "Manage",
	change: "Change",
	"enter-number": "Enter number",
	"enter-text": "Enter text",
	reset: "Reset",
	model: "Model",
	"goto-original": "Go to original",
	"select-table": "Select table",
	"no-date": "No date",
	inbox: {
		"empty-state": { title: "No notes yet", description: "Click “+” above\nto add your first note" },
		author: "Author",
		"add-note": "Add note",
		expand: "Show full note",
		collapse: "Collapse",
		"empty-content": "Note content is empty",
		placeholders: {
			title: "Item title",
			content: "Item content",
		},
		name: "Inbox",
		"new-note": "New item",
		"no-catalog-notes": "No items in the current catalog",
		"search-placeholder": "Search author...",
		"no-user-with-this-name": "Author not found",
	},
	template: {
		"empty-state": {
			title: "No templates yet",
			description:
				"Create templates with variables to quickly fill in content. Click “+” to create your first template",
		},
		name: "Templates",
		placeholders: {
			title: "Template title",
			content: "Template content",
		},
		"new-template": "New template",
		"no-templates": "No templates",
		warning: {
			content: {
				name: "Insert template {{template}} into article?",
				body: "The article text will be replaced with the template. If you do not want to lose it — cancel the insertion and move the text to another article.",
			},
		},
		"choose-template": "Choose template",
		"select-property": "Select property",
	},
	clear: "Clear",
	yes: "Yes",
	no: "No",
	placeholder: "Placeholder",
	fragments: "Fragments",
	"fragments-panel-empty-state": {
		title: "No fragments yet",
		description:
			"Save reusable content to quickly insert it into articles. Click “+” to create your first fragment",
	},
	"fragments-panel-title": "Fragments",
	"fragments-panel-create": "Create fragment",
	"fragments-panel-search": "Search fragments...",
	"fragments-panel-loading": "Loading fragments",
	"fragments-panel-empty": "No fragments found",
	"fragments-panel-untitled": "Untitled",
	"fragments-panel-no-content": "No content",
	"fragments-panel-manage": "Manage fragments",
	"new-fragment": "New fragment",
	"no-fragments": "No fragments in the current catalog",
	"fragment-no-usages": "Fragment is not used in any articles",
	ai: {
		"search-prompts": "Search prompts",
		"no-prompts": "No prompts found",
		"ai-prompts": "AI Prompts",
		"ask-ai": "Ask AI anything",
		generate: "Generate text",
		generating: "Generating...",
		transcribe: {
			name: "Transcription",
			description: "Recognize speech from a media file",
			click: "Record",
			access: "Click to request access to the microphone",
			"browser-denied": "Microphone access is denied. Allow access in browser settings",
			"system-denied": "Microphone access is denied. Allow access in system settings",
			loading: "Checking microphone access...",
			notSupported: "Your browser does not support microphone access",
			recording: "Recording",
			reset: "Click to reset recorded audio",
			pause: "Click to pause",
			resume: "Click to resume",
			warningHomeSend: "You can't save audio from the home page",
			modal: "<p>After transcription, the recognized text will appear.</p><p>You can edit the text to improve its quality. To do this, click on the input field and edit it.</p>",
			"limit-reached":
				"The limit of 5 minutes has been reached. You can continue recording after saving the current audio.",
			history: "Audio history",
			modalAttention:
				"<p><strong>Attention!</strong> The recognized text is not saved anywhere. If you want to save it, you can copy it to the clipboard.</p>",
		},
		responseError: {
			title: "AI server response error",
			body: `<p>Try again later or contact your administrator.<br/>If the error blocks work — create an issue in <a href="https://github.com/Gram-ax/gramax/issues">GitHub</a>.</p>`,
		},
		transcribtion: "Transcribtion...",
		placeholder: {
			prettify: "What to do with the selected text ✨",
			generate: "Write something beautiful ✨",
		},
		warning: {
			"generate-many-selection": "You can only work with the selected text through the popup editor",
		},
		prompt: {
			placeholder: {
				title: "Prompt title",
				content: "Prompt content",
			},
			"new-prompt": "New prompt",
			"no-prompts": "No prompts in the current catalog",
		},
	},
	"mark-as-read": "Mark as read",
	"already-read": "Read",
	"add-favorite": "Add to favorite",
	"remove-favorite": "Remove from favorite",
	favorites: "Favorite",
	home: "Home",
	"favorites-articles": "Favorite articles",
	"no-favorites-in-catalog": "No favorite article in the current catalog",
	"inline-to-block-image": "Inline to block image",
	"save-file": "Save file",
	"confirm-inbox-note-delete": "Are you sure you want to delete this item?",
	"confirm-prompts-delete": "Are you sure you want to delete this prompt?",
	"confirm-templates-delete": "Are you sure you want to delete this template?",
	"templates-panel-title": "Templates",
	"templates-panel-create": "Create template",
	"templates-panel-search": "Search templates...",
	"templates-panel-loading": "Loading templates",
	"templates-panel-empty": "No templates found",
	"templates-panel-untitled": "Untitled",
	"templates-panel-no-content": "No content",
	"templates-panel-manage": "Manage templates",
	"templates-panel-actions": "Template actions",
	"confirm-agent-skills-delete": "Are you sure you want to delete this agent skill?",
	download: "Download",
	tools: "Tools",
	"zoom-in": "Zoom in",
	"zoom-out": "Zoom out",
	write: "Enter",
	select2: "Select",
	"change-theme": "Change theme",
	"change-language": "Change language",
	"new-section": "New section",
	"add-section": "Add section",
	"convert-to-folder": "Convert to folder",
	"convert-to-folder-disabled-empty": "Can't convert to folder: the section is empty",
	"convert-to-section": "Convert to section",
	"folder-title": "Folder title",
	"folder-more-catalogs": "More",
	"folder-catalogs-count-one": "catalog",
	"folder-catalogs-count-few": "catalogs",
	"folder-catalogs-count-many": "catalogs",
	"go-back": "Back",
	"drop-to-uncategorize-hint": "Drag a catalog here to return it to the main page.",
	"empty-section-title": "There's nothing here yet",
	"empty-section-description": "Add catalogs by dragging them here.",
	"drag-to-reorder-section": "Move section",
	"more-actions": "More actions",
	"home-view": "Homepage view",
	"personal-view": "Personal",
	"shared-view": "Shared",
	"shared-homepage-view-description":
		"This view is used on the docportal and in the editor for users who have not configured a personal view.",
	"edit-homepage-view": "Edit homepage",
	"edit-homepage-view-disabled-duplicate-catalog":
		"Editing the homepage is not available — a catalog is listed in more than one section",
	"only-workspace-owner-can-edit-shared-view": "Only workspace owners can edit the shared view",
	"configure-home-view": "Configure home view",
	"configure-personal-view": "Configure personal view",
	"configure-view-for-everyone": "Configure view for everyone",
	"section-title": "Section title",
	"uncategorized-title": "Uncategorized",
	authorization: "Authorization",
	create: "Create",
	"choose-space": "Choose space",
	"try-again": "Try again",
	upload: "Upload",
	"fileupload-description": "Drag & drop or click to browse",
	"file-not-found": "File not found",
	"open-in-supported-app": "Open in supported app",
	welcome: {
		empty: {
			title: "It's empty so far",
			description: "The administrator has not added any catalogs yet.",
		},
		"empty-clone": {
			title: "Welcome to Gramax!",
			description: "Start by loading an existing catalog from storage",
		},
		editor: {
			title: "Welcome to Gramax!",
			description: "Create a docs in Gramax and publish them as a fast, modern website with AI-powered search",
			options: {
				"create-blank": {
					title: "Create a blank catalog",
					description: "Start from scratch",
				},
				"download-exists": {
					title: "Link GitHub or GitLab",
					description: "Connect Gramax to your Git repository",
				},
				"import-exists": {
					title: "Import documentation",
					description: "Move your docs from Notion or Confluence",
				},
			},
		},
	},
	"try-later": "Please try again later",
	"file-upload": {
		"file-too-large": "File ${fileName} exceeds the maximum size of ${maxSizeBytes}.",
		"invalid-file-type": "File ${fileName} is not an accepted file type.",
		"single-file-too-large": "File exceeds the maximum size of ${maxSizeBytes}.",
		"some-files-too-large": "Some files exceed the maximum size of ${maxSizeBytes}",
		"too-many-files": "You can only upload a maximum of ${maxFiles} files",
	},
	"file-preview": {
		file: "File",
		of: "of",
		page: "Page",
		pages: "Pages",
		"preview-error": "Unfortunately, file {fileName} is not supported for preview",
		ready: "Preview",
		"render-error": "Failed to render this file",
		sheet: "Sheet",
		sheets: "Sheets",
		title: "File preview",
		"zoom-in": "Zoom in",
		"zoom-out": "Zoom out",
	},
	empty: "Empty",
	pagination: {
		shown: "Shown {count} of {total}",
		previous: "Previous",
		next: "Next",
	},
	confirmation: {
		delete: {
			title: "Confirm deletion",
			body: "Are you sure you want to delete {count} {item}?",
		},
		unsaved: {
			title: "Unsaved changes",
			body: "Your changes will be lost if you continue without saving.",
		},
		unsaved2: {
			title: "Close without saving?",
			body: "Your unsaved changes will be lost.",
		},
		buttons: {
			cancel: "Back",
		},
		"unsaved-comment": {
			title: "Close without saving?",
			body: "You have made changes, but you have not published them. If you close the window, the changes will be lost.",
			buttons: {
				primary: "Continue editing",
				secondary: "Do not save",
			},
		},
		"convert-section-with-folders": {
			title: "Convert section with folders?",
			body: 'This section contains folders. The catalogs will be collected into a new folder, and the existing folders will be moved to the "Uncategorized" section.',
			buttons: {
				primary: "Convert",
				secondary: "Cancel",
			},
		},
		"delete-homepage-section": {
			title: "Delete section?",
			body: "The section will be removed and its items will move to Uncategorized.",
		},
		"delete-homepage-folder": {
			title: "Delete folder?",
			body: "The folder will be removed and its catalogs will move back to the section.",
		},
		"empty-sections-on-save": {
			title: "There are empty sections",
			body: "Some sections don't contain any catalogs. They will be removed on save. Save changes?",
			buttons: {
				primary: "Save",
				secondary: "Cancel",
			},
		},
		"discard-homepage-changes": {
			title: "Discard changes?",
			body: "You have unsaved changes to the homepage layout. If you discard them, they will be lost.",
			buttons: {
				primary: "Discard",
				secondary: "Continue editing",
			},
		},
		"leave-edit-mode": {
			title: "Leave edit mode?",
			body: "You have unsaved changes. If you leave edit mode, they will be lost.",
			buttons: {
				primary: "Leave",
				secondary: "Continue editing",
			},
		},
	},
	"save-and-close": "Save",
	"editing-personal-homepage-view": "Editing personal view",
	"editing-shared-homepage-view": "Editing shared view",
	record: "record",
	records: "records",
	"already-added": "Already added",
	"available-changes-sync": "Available changes for synchronization",
	comments: {
		answers: {
			one: "answer",
			few: "answers",
			many: "answers",
		},
		move: {
			up: "Previous comment",
			down: "Next comment",
		},
		diff: {
			single: {
				added: "Added comment",
				deleted: "Deleted comment",
				modified: "Modified comment",
			},
			multiple: {
				title: "Comments changes",
				added: "Added",
				deleted: "Deleted",
				modified: "Modified",
			},
		},
	},
	quiz: {
		info: {
			title: "Questions",
			question: "Question",
			answered: "Answered",
			total: "Total",
			send: "Send answers",
			retake: "Retake test",
			statistics: {
				title: "Statistics",
				"correct-answers": "Correct answers",
				passed: "Passed",
				failed: "Failed",
			},
		},
		settings: {
			name: "Quiz settings",
			"show-answers": {
				title: "Show answers",
				description: "Show answers to the questions after the test is completed",
			},
			retake: {
				title: "User can retake the test",
				description: "Allow users to retake the test if they fail it",
			},
			"precent-of-correct-answers": {
				title: "Count of correct answers",
				description: "The count of correct answers to pass the test",
				placeholder: "Number between 0 and 100",
			},
		},
		"answer-placeholder": {
			edit: "Here will be the field for entering text",
			render: "Write the answer",
		},
		"required-questions": "Please answer all required questions",
	},
	or: "or",
	errors: {
		"workspace-path-not-found": "Space with path {{path}} not found",
		"workspace-access-denied": "No access to the space in the directory:",
		"workspace-access-denied-title": "No access to the space",
		"workspace-access-denied-other": "Check the permissions on this directory.",
		"workspace-access-denied-macos":
			"Go to System Settings → Privacy & Security → Files and Folders and let Gramax use this directory.",
		"workspace-access-denied-macos-category":
			"Go to System Settings → Privacy & Security → Files and Folders and turn on {{category}} for Gramax.",
		"tcc-category": {
			desktop: "Desktop Folder",
			documents: "Documents Folder",
			downloads: "Downloads Folder",
			icloud: "iCloud Drive",
		},
		"open-system-settings": "Open Settings",
	},
	diagrams: "Diagrams",
	plugins: {
		messages: {
			"load-error": "Failed to load {name} module",
			"sdk-incompatible-title": "Module “{name}” was not started",
			"sdk-incompatible-description":
				"This module version is incompatible with your version of Gramax. Contact your space administrator and ask them to update the module.",
			"already-exists": "Module with ID {id} already exists",
			"built-in-cannot-delete": "Built-in module cannot be deleted",
		},
		list: {
			"no-plugins-title": "No modules configured",
			"no-plugins-description":
				"Upload module folders to extend Gramax functionality. Each module folder must contain a manifest.json file and a JavaScript file.",
			"add-button": "Add Module",
			"upload-button": "Upload Module Folder",
			saving: "Saving...",
			save: "Save",
			sync: "Synchronize",
			"disabled-badge": "Disabled",
			enabled: "Enabled",
			disabled: "Disabled",
		},
		detail: {
			"current-status": "Disabled",
			delete: "Delete",
			"not-found-title": "Module not found",
			"not-found-description": "Please select a module from the sidebar",
			fields: {
				name: "Name",
				id: "ID",
				version: "Version",
				author: "Author",
				description: "Description",
				"sdk-version": "SDK version in Gramax",
				"sdk-range": "Supported SDK versions",
				status: "Status",
			},
			status: {
				enable: "Включен",
				disable: "Отключен",
			},
		},
		"delete-modal": {
			title: "Delete Module",
			content: 'Are you sure you want to delete the module "{name}"?',
			"batch-content": "Are you sure you want to delete {count} module(s)?",
			description: "This action cannot be undone",
			cancel: "Cancel",
			confirm: "Delete",
		},
		"save-modal": {
			title: "Save Changes",
			content: "Do you want to save the changes?",
			cancel: "Cancel",
			confirm: "Save",
		},
	},
	metrics: {
		title: "Metrics",
		"data-for": "Data for",
		"failed-to-load": "Failed to load metrics data",
		disabled: "The metrics module is disabled",
		enabled: "The metrics module is enabled",
		"disabled-hint": "Metrics are disabled. Enable them using the toggle above.",
		filters: {
			date: {
				today: "Today",
				yesterday: "Yesterday",
				"this-week": "This Week",
				"last-7-days": "Last 7 Days",
				"last-28-days": "Last 28 Days",
				"this-month": "This Month",
				"last-month": "Last Month",
				"this-year": "This Year",
				"custom-range": "Custom Range",
				cancel: "Cancel",
				apply: "Apply",
			},
			users: {
				"users-filter": "Users",
				"all-users": "All Users",
				"users-selected": "users selected",
				"search-users": "Search users...",
				"no-users-found": "No users found",
				"type-to-search": "Type to search users",
				"clear-selection": "Clear selection",
				anonymous: "Anonymous",
				loading: "Loading...",
			},
			anonymous: {
				label: "User type",
				all: "All users",
				registered: "Registered only",
				anonymous: "Anonymous only",
			},
			catalog: {
				placeholder: "Catalogs",
				all: "All catalogs",
				search: "Search catalogs...",
				"clear-selection": "Clear selection",
				"no-results": "No catalogs found",
			},
		},
		chart: {
			visitors: "Visitors",
			visits: "Visits",
			views: "Views",
			total: "Total",
			daily: "Daily",
			weekly: "Weekly",
			monthly: "Monthly",
			"daily-breakdown": "Daily breakdown",
			"weekly-breakdown": "Weekly breakdown",
			"monthly-breakdown": "Monthly breakdown",
			totalSearches: "Total Searches",
			avgCTR: "Avg CTR",
			noClickRate: "No-Click Rate",
			refinementRate: "Refinement Rate",
		},
		searchChart: {
			title: "Search metrics overview",
		},
		viewChart: {
			title: "View history overview",
		},
		table: {
			"catalog-name": "Catalog",
			"parent-article": "Parent article",
			article: "Article",
			visitors: "Visitors",
			visits: "Visits",
			pageviews: "Pageviews",
			"search-query": "Search Query",
			"search-count": "Search Count",
			"unique-visitors": "Unique users",
			"ctr-percent": "CTR",
			"most-clicked-item": "Most Clicked Item",
			"avg-click-position": "Avg Click Position",
			"refinement-rate-percent": "Refinement Rate",
			catalog: "Catalog",
			pinned: "Pinned",
			yes: "Yes",
			no: "No",
			clicks: "Clicks",
			"avg-position": "Avg Position",
			searches: "Searches",
			"refinement-percent": "Refinement (%)",
			tooltips: {
				"ctr-percent":
					"Click-Through Rate - the percentage of searches that resulted in a click on a search result",
				"avg-click-position":
					"The average position in search results where users clicked. Lower numbers indicate users found relevant results higher in the list",
				"refinement-rate-percent":
					"The percentage of searches where users modified their query to refine their search",
				"no-click-rate": "The percentage of searches where users did not click on any search result",
			},
		},
		"no-data": "No data available",
		search: {
			"statistics-title": "Search Queries Statistics",
			"query-details-title": "Query Details",
			"article-ratings-title": "Article Ratings by Search",
		},
	},
	"form-errors": {
		minLength: "Minimum length {min} characters",
		maxLength: "Maximum length {max} characters",
		required: "Required field",
		pattern: "Invalid format",
		validate: "Invalid value",
	},
	rename: "Rename",
	"storage-stats": {
		git: "Git",
		lfs: "LFS",
		"pack-files": "Pack Files",
		"loose-objects": "Loose Git Objects",
		"lfs-objects": "Used LFS Objects",
		unreachable: "Unreachable Git Objects",
		prunable: "Unreachable LFS Objects",
		cleanup: "Cleanup",
		error: "Failed to load storage stats",
		retry: "Retry",
		confirm: {
			title: "Confirm cleanup",
			git: "This will remove unreachable Git objects from the repository. This action cannot be undone",
			lfs: "This will delete LFS files that are no longer referenced. This action cannot be undone",
		},
		tooltips: {
			lfs: "Git LFS binary files used by the repository",
			"pack-files": "Compressed Git objects combined into pack files. Required for Git and can not be removed",
			"loose-objects": "Reachable Git objects not yet packed",
			unreachable: "Loose objects that are no longer referenced by any branch, tag or commit. Safe to remove",
			prunable: "LFS files that are no longer referenced. Safe to prune to free up disk space",
			"git-clear": "Loose objects will be compressed into pack files, and unreachable objects will be removed.",
			"lfs-clear": "Unreachable LFS files will be deleted.",
		},
	},
	files: {
		one: "file",
		few: "files",
		many: "files",
	},
	agent: {
		"empty-state": {
			title: "How can I help?",
			description: "I read and write articles, and search\nthe web for what you need – just ask",
		},
		"message-too-long": "Message is too long",
		"view-json": "Show JSON",
		expand: "Expand",
		collapse: "Collapse",
		"availability-error": {
			enterprise: {
				title: "AI agent is unavailable",
				description: "Couldn’t connect to the AI agent. Contact your administrator.",
			},
			"enterprise-cloud": {
				title: "AI agent is temporarily unavailable",
				description: "Couldn’t connect to the service. Try again later.",
				"balance-empty": {
					title: "Your organization’s AI balance is depleted.",
					description: "Top up the balance to continue using the AI agent.",
				},
			},
		},
		thinking: "Thinking...",
		"thinking-working": "Working",
		"thinking-worked": "Worked for",
		"thinking-done": "Worked",
		"duration-minutes": "m",
		"duration-seconds": "s",
		skills: {
			"empty-state": {
				title: "No skills yet",
				description:
					"Save prompts to quickly use them in the AI agent chat. Click “+” to create your first skill",
			},
			name: "Agent Skills",
			"menu-name": "Skills",
			"new-skill": "New skill",
			"no-skills": "No agent skills in the current catalog",
			loading: "Loading…",
			"attach-file": "Attach file",
			manage: "Manage skills",
			"search-placeholder": "Search skills...",
			"title-placeholder": "Skill name",
			"content-placeholder": "Skill description",
			"unnamed-skill": "Unnamed skill",
			"no-content": "No content",
		},
		input: {
			placeholder: "Enter a question or command...",
			"file-too-large": "File is too large. Maximum size is {{maxSizeMb}} MB.",
			"file-invalid-format": "Invalid file format.",
		},
		history: {
			empty: "No chat history",
			"new-chat": "New chat",
			"search-placeholder": "Search recent chats...",
			"delete-confirm-title": "Delete chat?",
			"delete-confirm-description": "The chat “{{title}}” and its message history will be permanently deleted.",
		},
		usage: {
			"tooltip-label": "Show context usage",
			"tooltip-title": "Context window",
			"tooltip-percent": "{{used}}% used ({{left}}% left)",
			"tooltip-tokens": "{{used}} / {{total}} tokens used",
			"tooltip-view-context": "View sent context",
			modal: {
				title: "Context",
				"percent-full": "{{percent}}% Full",
				"percent-unknown": "—% Full",
				"tokens-of-window": "{{used}} / {{total}} Tokens",
				"row-last-turn": "Last agent response",
				"row-uncached": "Uncached tokens",
				"sent-context": "Sent context",
				"context-loading": "Loading…",
				"context-error": "Failed to load context",
				"context-retry": "Retry",
			},
		},
		"chat-error": {
			"session-not-found": "Chat session has been refreshed. Please try sending your message again.",
			"session-cancelled": "Session was cancelled. Creating a new one…",
			"empty-message": "Please enter a message.",
			"agent-failed": "Failed to get assistant response. Please try again.",
			"load-history-error": "Failed to load chat history.",
			"no-active-session": "No active chat session.",
			"send-message-error": "Failed to send message. Please try again.",
			"get-response-error": "Failed to get response. Please try again.",
			"chat-connection-failed": "Failed to connect to chat. Please check your connection and try again.",
			"delete-session-error": "Failed to delete session. Please try again.",
			"rename-session-error": "Failed to rename chat. Please try again.",
		},
		"error-type": {
			unauthorized:
				"API key is missing or invalid. Contact your administrator to check the AI service configuration.",
			forbidden: "The AI agent requires the editor role. Contact your workspace administrator.",
			payment_required: "Payment or subscription is required to continue.",
			max_steps_exceeded: "The agent stopped because the maximum number of steps was exceeded.",
			network_error: "Network error. Please check your connection and try again.",
			unexpected: "An unexpected error occurred.",
			"unexpected-with-message": "Unexpected error: {{message}}",
		},
		"missing-secret": {
			verb: { one: "Missing", few: "Missing", many: "Missing" },
			"noun-token": { one: "token", few: "tokens", many: "tokens" },
			"noun-login": { one: "login", few: "logins", many: "logins" },
			and: "and",
			"description-one":
				"Without it, the request wasn't completed. Add it in settings — the agent will be able to continue working.",
			"description-many":
				"Without them, the request wasn't completed. Add them in settings — the agent will be able to continue working.",
			button: "Add",
		},
		"warning-type": {
			cache_hit_zero: "Context cache was not used in this request.",
		},
		"turn-cancelled": "Agent work was interrupted by the user",
		"stopped-after": "You stopped after",
		"context-compacted": "Context compacted",
		browser: {
			badge: "Browser",
			allow: "Web search",
			tooltip: "Open browser",
			"tooltip-title": "Enable web search",
			"tooltip-text": "Lets the agent find up-to-date information on the internet and use it in its work.",
			"tooltip-desktop-only": "This feature is only available in the desktop version of the app.",
		},
		"panel-name": "AI agent",
		tooltips: {
			"toggle-chat": "Open AI agent",
			add: "Add file and more",
			history: "Chat history",
			"new-chat": "New chat",
			close: "Close",
			"rename-session": "Rename chat",
			"delete-session": "Delete chat",
			"remove-quote": "Remove quote",
		},
		"ask-agent": "Ask agent",
		tools: {
			tools: "Tools",
			parameters: "Parameters",
			result: "Result",
			list_catalogs: "Retrieving catalog list",
			get_navigation: "Retrieving navigation tree",
			search_catalogs: "Searching articles",
			search_files: "Searching files",
			read_catalog_item: "Reading article",
			get_files_navigation: "Retrieving repository navigation tree",
			read_file: "Reading file",
			get_catalog_item_headings: "Retrieving article headings",
			create_catalog_item: "Creating article",
			write_catalog_item: "Updating article",
			replace_catalog_item: "Updating article",
			delete_catalog_item: "Deleting article",
			move_catalog_item: "Moving article",
			git_inspect: "Reading git changes",
			git_discard: "Discarding git changes",
			git_branch: "Working with git branches",
			git_restore: "Restoring files from git",
			read_agent_skill: "Reading skill",
			read_document: "Reading document",
			save_chat_attachment: "Saving attachment to article",
			transcribe_audio: "Transcribing audio",
			search_web: "Searching the web",
			http_request: "Sending HTTP request",
			mail_request: "Sending mail request",
			browser_navigate: "Opening page in browser",
			browser_read_page: "Reading page in browser",
			browser_read_element: "Reading page element",
			browser_click: "Clicking page element",
			browser_type: "Typing on page",
			browser_scroll: "Scrolling page",
			compact_context: "Compacting context",
		},
	},
	"app-settings": {
		title: "Settings",
		description: "Manage your application",
		level: {
			title: "Settings level",
			app: "Application",
			workspace: "Workspace",
			catalog: "Catalog",
		},
		tabs: {
			general: "General",
			"compress-images": "Image Compression",
			services: "Services",
			updates: "Auto-updates",
			diagnostics: "Diagnostics",
			"experimental-features": "Experimental",
			editor: "Editor",
			"content-compare": "Compare",
			"keys-passwords": "Keys and passwords",
			"ai-agent": "AI agent",
		},
		sections: {
			general: {
				title: "General",
				description: "Interface language, appearance, and how images are processed when added to articles.",
			},
			services: {
				title: "Services",
				description: "Endpoints Gramax connects to. Change them only for your own deployments.",
			},
			updates: {
				title: "Auto-updates",
				description: "How the app checks for and installs new versions.",
			},
			diagnostics: {
				title: "Diagnostics",
				description: "App logs for investigating errors and attaching details to a support request.",
			},
			"experimental-features": {
				title: "Experimental features",
				description: "Features still in development. They may be unstable and change in future versions.",
			},
			"content-compare": {
				title: "Version comparison",
				description: "How changes are highlighted when you compare article versions.",
			},
		},
		"exit-confirmation": {
			title: "Are you sure you want to leave?",
			body: "Your changes will not be saved",
			"keep-editing": "Back to editing",
			exit: "Leave",
		},
		actions: {
			cancel: "Cancel",
			"reset-section": "Reset to defaults",
			"reset-field": "Reset to default",
		},
		general: {
			language: {
				title: "Interface language",
				placeholder: "Select language",
				en: "English",
				ru: "Русский",
			},
			theme: {
				title: "Theme",
				placeholder: "Select theme",
				light: "Light",
				dark: "Dark",
			},
		},
		"compress-images": {
			enabled: "Compress images",
			"enabled-description": "Images are compressed when added to an article and saved as webp.",
			rule: "Rule",
			source: "Compress images",
			target: "Save as",
			effort: "Compression effort",
			"effort-description": "Higher effort produces a smaller file but takes longer.",
			quality: "Quality",
			"quality-description": "Lower quality produces a smaller file.",
			"compression-level": "Compression level",
			"compression-level-description": "Lossless. A higher level produces a smaller file but takes longer.",
			add: "Add rule",
			empty: "No compression rules. Images are saved as-is.",
		},
		services: {
			"web-editor": {
				title: "Web editor",
				description: "Gramax web editor service URL.",
			},
			auth: {
				title: "Authentication",
				description: "User authentication service URL.",
			},
			"diagram-renderer": {
				title: "Diagram Renderer",
				description: "Diagram rendering service URL.",
			},
			"git-proxy": {
				title: "Git Proxy",
				description: "Proxy for browser-based Git operations.",
			},
			ai: {
				title: "AI",
				enabled: "Enable AI",
				endpoint: "AI endpoint",
				token: "AI token",
			},
		},
		diagnostics: {
			logging: {
				title: "Logging",
				description: "What gets written to the log files on this device.",
				console: "Print logs to console",
				"console-description": "Also duplicate log output to the developer console.",
			},
			troubleshooting: {
				title: "Troubleshooting",
				description: "Export a log archive to attach to a bug report or support request.",
			},
		},
		updates: {
			frequency: {
				title: "Update check frequency",
				description: "How often the app automatically checks for updates. Manual check works with any setting.",
				"every-launch": "On every launch",
				daily: "Once a day",
				weekly: "Once a week",
				never: "Never",
			},
			check: {
				action: "Check for updates",
				checking: "Checking for updates...",
				"update-found": "Update found, downloading",
				"up-to-date": "You have the latest version",
				"in-progress": "Update is already downloading",
				error: "Failed to check for updates",
			},
			"install-from-cache": {
				description: "Select a version archive from the update cache. The app will install it and restart.",
				action: "Install from cache",
				error: "Failed to install version from cache",
			},
		},
		"keys-passwords": {
			title: "User keys and passwords",
			description: "Store keys, passwords and logins for reuse in secure variables.",
			"search-placeholder": "Search by name...",
			"kind-label": "Type",
			"kind-token": "Token",
			"kind-login": "Login",
			"key-placeholder": "Name",
			"key-label": "Name",
			"login-label": "Login",
			"login-disabled-tooltip": "Available only for the “Login” type",
			"url-label": "URL",
			"value-placeholder": "Value",
			"value-label": "Password or key",
			"key-required": "Key is required",
			"key-duplicate": "This token or login already exists — enter a different name",
			"delete-confirm-title-token": "Delete token?",
			"delete-confirm-title-login": "Delete login?",
			"delete-confirm-description": "Skills that use “{{key}}” will stop working until it’s added again.",
			add: "Add",
			manage: "Manage keys and passwords",
		},
		"content-compare": {
			sensitivity: {
				title: "Highlight granularity",
				description:
					"Words read cleaner. Letters show exactly what changed. Hybrid highlights letters for small edits and the whole word for larger ones.",
				hybrid: "Hybrid",
				character: "Letters",
				word: "Words",
			},
			"min-similarity": {
				title: "Paragraph matching",
				description:
					"How far a paragraph can drift before it stops counting as an edit. Raise it to split heavy rewrites into a deletion and an addition.",
			},
			debounce: {
				title: "Update delay",
				description:
					"Time to settle after typing before the diff redraws. Raise it if long articles feel sluggish.",
			},
			"min-match-length": {
				title: "Noise threshold",
				description:
					"Short fragments that survive a rewrite by coincidence still count as unchanged. Raise it to drop them and keep the highlights meaningful.",
			},
			preview: {
				title: "Preview",
				before: {
					typo: "Gramax keeps documentation in a Git repositry.",
					reworded:
						"A catalog is a set of articles bound together by shared navigation and access settings for the team.",
					survivors: "To build an article, you need to press the button and wait.",
				},
				after: {
					typo: "Gramax keeps documentation in a Git repository.",
					reworded: "A catalog gathers articles into a single navigation tree.",
					survivors: "To publish an article, you need to press the button and wait a little.",
				},
			},
		},
	},
};

export default locale;
